/**
 * 인입 경로
 */
import { HCostConst } from "@constants/hcost/hcost-const";
import { ProfitConst } from "./profit-const";

export interface DataItem {
  code: string;
  value: string;
  text: string;
}
export enum INFLOWTYPE {
  H_COST_RESULT, // 간편견적
  STARTUP_RESULT, // 수익성 분석
  HANDWORK = 3, // 직접입력
  H_COST_COUNSEL, // 시공상담
}
export enum PROGRESS_STATUS {
  PREPARATION = "P01", // 준비
  CONSULTATION_STOP = "P02", // 종료
  CONSULTATION_REQUEST = "P03", // 상담요청
  CONSULTING = "P04", // 상담중
  DESIGN_ESTIMATE = "P05", // 설계/견적중
  CONSULTATION_COMPLETE = "P06", // 상담완료
  CONTRACT = "P07", // 계약중
  CONTRACT_COMPLETED = "P08", // 계약 완료
  CONSTRUCTION = "P09", // 시공중
  CONSTRUCTION_COMPLETED = "P10", // 시공 완료
  TRANSACTION_SETTLEMENT = "P11", // 거래/정산중
  COMPLETED = "P12", // 완료
}

export enum TRANSACTION_METHOD {
  UNDECIDED = "T01",
  MATERIALS = "T02",
  MATERIALS_CONSTRUCTION = "T03",
  CONSTRUCTION = "T04",
}

export enum REASON_FOR_DISCONTINUATION {
  CONTACT_FAILED = "R01", // 연락 실패
  COUNSELING_FAILED = "R02", // 상담 실패
  DESIGN_AND_ESTIMATE_FAILURE = "R03", // 설계/견적 실패
  CONTRACT_FAILURE = "R04", // 계약 실패
  CONSTRUCTION_FAILURE = "R05", // 시공 실패
  INCONGRUITY = "R06", // 부적합
  TRANSACTION_SETTLEMENT_FAILED = "R07", // 거래/정산 실패
}

export enum CON_SOURCE {
  FARMMORNING = "S01",
  COMPANY = "S02",
}

export enum CALC_TYPE {
  HCOST = "01",
  VHOWS = "02",
}

export enum FACILITY_TYPE {
  WAREHOUSE = "F01", // 농막/창고/반반 하우스
  RAIN_PROOF = "F02", // 우산형 비가림 시설
  SINGLE = "F03", // 단동 하우스
  INTERLOCK = "F04", // 연동 하우스
  VENLO = "F05", // 벤로 하우스
  GLASS = "F06", // 유리 온실
  DOUBLE_WIDTH = "F07", // 밀양식 광폭 하우스
  OUTDOORS_IRRIGATION = "F08", // 노지 시설/관수
  REPAIR = "F09", // 교체/업그레이드
  OTHER = "F10", // 기타
  SMARTFARM = "F11", // 스마트팜
}
export enum DESIGN_ITEM_CATEGORY1 {
  ARCHITECTURE = "A", // 건축 시설
  ADD = "B", // 추가 시설
  VENT = "C", // 환기 설비
  WATERING = "D", // 관수 설비
  HYDROPONICS = "E", // 양액 설비
  TEMPERATURE = "F", // 냉난방 설비
  ENVIRONMENT = "G", // 환경 설비
  OTHER = "Z", // 기타 설비
}

export enum DESIGN_ITEM_CATEGORY2 {
  FOUNDATION = "001", // 기초
  FRAME = "002", // 골조
  COVER = "003", // 피복
  SWITCH = "004", // 개폐
  CURTAIN = "005", // 수평 커튼
  SKYLIGHT = "006", // 지붕(천창) 개폐
  VENT_EXHAUST = "007", // 외부 배기
  VENT_INSIDE = "008", // 내부 환기
  SASH_WINDOW = "009", // 샷시 창문
  WATERING_FOG = "010", // 포그 관수
  WATERING_SPRINKLER = "011", // 스프링클러 관수
  WATERING_DRIP = "012", // 점적 관수
  WATERING_SCREEN = "013", // 수막 관수
  HYDROPONICS_SUBSTRATE_CULTURE = "014", // 고형배지 양액 설비
  HYDROPONICS_NFT = "015", // NFT 양액 설비
  HEATING_WARM_WATER = "016", // 온수 난방
  HEATING_STEAM = "017", // 증기 난방
  HEATING_WARM_AIR = "018", // 온풍 난방
  HEATING_DIRECT_TUBE = "019", // 직열튜브 난방
  HEATING_GROUND_PUMP = "020", // 지열히트펌프
  WATER_TANK_CHILLER = "021", // 물탱크 칠러
  AIRCONDITIONER = "022", // 에어컨
  ENVIRONMENT = "023", // 복합환경제어 설비
  CO2 = "024", // CO2 설비
  AUTOSPRAY = "025", // 자동 방제기
  WORKROOM = "026", // 작업부/작업동
  RACK = "027", // 선반/균상다이
  RAIL = "028", // 운반 레일
  GROUND_FLAT = "029", // 지반평탄화/배수로
  CONCRETE = "030", // 바닥 콘크리트
  WASHROOM = "031", // 화장실/정화조/관정
  CONTAINER = "032", // 컨테이너
}

export enum DESIGN_ITEM_CATEGORY3 {
  NOTHING = "000",
  GATE_FRONT = "001",
  GATE_BACK = "002",
  COVER_OUTER = "003",
  COVER_INNER = "004",
  SWITCH_SIDE = "005",
  CURCOVER = "006",
  SWITCH_ROOF = "007",
  VENT_EXHAUST = "008",
  VENT_INSIDE = "009",
  WINDOW = "010",
}

export enum ITEM_TYPE {
  DETAIL = "D",
  INTEREST = "F",
}

export const DesignItemNumber = {
  foundation: {
    foundation: "A001000000",
  },
  frame: {
    frame: "A002000000",
    gate_front: {
      none: "A002001001",
      sliding: "A002001002",
      hinged: "A002001003",
    },
    gate_back: {
      none: "A002002001",
      sliding: "A002002002",
      hinged: "A002002003",
    },
  },
  cover: {
    cover: "A003000000",
    outerCover: {
      none: "A003003001",
      vinyl: "A003003004",
      cover2: "A003003005",
      cover1: "A003003006",
      cover4: "A003003007",
      cover5: "A003003008",
    },
    innerCover: {
      none: "A003004001",
      vinyl: "A003004004",
      vinyl_nonwoven: "A003004009",
      vinyl_quilting: "A003004010",
    },
  },
  switch: {
    sideswitch: {
      sideswitch: "A004000000",
      none: "A004005001",
      switcher_manual: "A004005015",
      switcher_power: "A004005016",
    },
  },
  curcover: {
    curcover: "B005000000",
    none: "B005006001",
    quilting: "B005006011",
    quilting_shadenet: "B005006012",
    quilting_screen: "B005006013",
    quilting_screen_screen: "B005006014",
  },
  skylight: {
    roofswitch: {
      roofswitch: "B006000000",
      none: "B006007001",
      switcher_power: "B006007016",
      skylight_frame_half: "B006007018",
      skylight_frame_rackpinion_way_both: "B006007019",
    },
  },
  ventexhaust: {
    ventexhaust: "C007000000",
    none: "C007008001",
    vent_exhaust_fan: "C007008020",
    vent_exhaust_roof_fan_manual: "C007008017",
  },
  ventinside: {
    ventinside: "C008000000",
    none: "C008009001",
    vent_inside_air_flow_fan: "C008009021",
  },
  window: {
    window: "C009000000",
    none: "C009010001",
    window_sash_frame: "C009010022",
    window_hinged: "C009010023",
  },
  watering_fog: {
    watering_fog: "D010000000",
  },
  watering_sprinkler: { watering_sprinkler: "D011000000" },
  watering_drip: { watering_drip: "D012000000" },
  watering_screen: { watering_screen: "D013000000" },
  hydroponics_substrate_culture: { hydroponics_substrate_culture: "E014000000" },
  hydroponics_nft: { hydroponics_nft: "E015000000" },
  heating_warm_water: { heating_warm_water: "F016000000" },
  heating_steam: { heating_steam: "F017000000" },
  heating_warm_air: { heating_warm_air: "F018000000" },
  heating_direct_tube: { heating_direct_tube: "F019000000" },
  heating_ground_pump: { heating_ground_pump: "F020000000" },
  water_tank_chiller: { water_tank_chiller: "F021000000" },
  airconditioner: { airconditioner: "F022000000" },
  environment: { environment: "G023000000" },
  co2: { co2: "G024000000" },
  autospray: { autospray: "G025000000" },
  workroom: { workroom: "Z026000000" },
  rack: { rack: "Z027000000" },
  rail: { rail: "Z028000000" },
  ground_flat: { ground_flat: "Z029000000" },
  concrete: { concrete: "Z030000000" },
  washroom: { washroom: "Z031000000" },
  container: { container: "Z032000000" },
};

export const InboundData = {
  inflowTypeForHcost: {
    label: "인입 경로",
    desc: "",
    items: [
      {
        text: "유선상담",
        value: HCostConst.inflowType.WIRELINE,
      },
      {
        text: "직접입력",
        value: HCostConst.inflowType.HANDWORK,
      },
      {
        text: "간편견적",
        value: HCostConst.inflowType.HCOST,
      },
      {
        text: "간편상담",
        value: HCostConst.inflowType.HCOUNSEL,
      },
    ],
  },
  inflowTypeForHcost_V2: {
    label: "인입 경로",
    desc: "",
    items: [
      {
        text: "직접입력",
        value: INFLOWTYPE.HANDWORK,
      },
      {
        text: "간편견적",
        value: INFLOWTYPE.H_COST_RESULT,
      },
      {
        text: "시공상담",
        value: INFLOWTYPE.H_COST_COUNSEL,
      },
    ],
  },

  inflowTypeForStartup: {
    label: "인입 경로",
    desc: "",
    items: [
      {
        text: "유선상담",
        value: ProfitConst.inflowType.WIRELINE,
      },
      {
        text: "직접입력",
        value: ProfitConst.inflowType.HANDWORK,
      },
      {
        text: "수익성 분석",
        value: ProfitConst.inflowType.PROFIT,
      },
    ],
  },
};

/**
 * 간편견적 데이터
 */
export const HCostData: any = {
  customerName: {
    label: "",
    desc: "",
    items: [],
  },

  customerPhone: {
    label: "",
    desc: "",
    items: [],
  },

  hCostMode: {
    label: "",
    desc: "",
    items: [
      {
        text: "초급자 모드",
        value: HCostConst.hcostMode.BIGINNER,
      },
      {
        text: "중급자 모드",
        value: HCostConst.hcostMode.INTERMEDIATE,
      },
    ],
  },

  basicStruct: {
    label: "",
    desc: "",
    items: [
      {
        text: "단동",
        value: "단동",
      },
      {
        text: "연동",
        value: "연동",
      },
      {
        text: "각연동",
        value: "각연동",
      },
      {
        text: "벤로",
        value: "벤로",
      },
      {
        text: "맞꽂이",
        value: "맞꽂이",
      },
      {
        text: "광폭",
        value: "광폭",
      },
      {
        text: "비가림",
        value: "비가림",
      },
    ],
  },
  conHouseType: {
    label: "",
    desc: "",
    items: [
      {
        text: "단동 하우스",
        value: "단동 하우스",
      },
      {
        text: "연동 하우스",
        value: "연동 하우스",
      },
      {
        text: "유리 온실",
        value: "유리 온실",
      },
      {
        text: "기타",
        value: "기타",
      },
    ],
  },

  conFacilityType: {
    label: "",
    desc: "",
    items: [
      {
        code: FACILITY_TYPE.WAREHOUSE,
        value: "농막/창고/반반 하우스",
      },
      {
        code: FACILITY_TYPE.SINGLE,
        value: "단동 하우스",
      },
      {
        code: FACILITY_TYPE.INTERLOCK,
        value: "연동 하우스",
      },
      {
        code: FACILITY_TYPE.VENLO,
        value: "벤로 하우스",
      },
      {
        code: FACILITY_TYPE.SMARTFARM,
        value: "환경제어 설비",
      },
      {
        code: FACILITY_TYPE.GLASS,
        value: "유리 온실",
      },
      {
        code: FACILITY_TYPE.DOUBLE_WIDTH,
        value: "밀양식 광폭 하우스",
      },
      {
        code: FACILITY_TYPE.RAIN_PROOF,
        value: "우산형 비가림 시설",
      },
      {
        code: FACILITY_TYPE.OUTDOORS_IRRIGATION,
        value: "노지 시설 / 관수",
      },
      {
        code: FACILITY_TYPE.REPAIR,
        value: "교체 / 업그레이드",
      },
      {
        code: FACILITY_TYPE.OTHER,
        value: "기타",
      },
    ],
  },

  basicBay: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100,
      step: 1,
      unit: "동",
    },
  },
  level: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 4,
      step: 1,
      unit: "중",
    },
  },
  basicLevel: {
    label: "",
    desc: "",
    items: [
      {
        text: "구분 없음",
        value: 0,
      },
      {
        text: "1중",
        value: 1,
      },
      {
        text: "2중",
        value: 2,
      },
      {
        text: "3중",
        value: 3,
      },
      {
        text: "4중",
        value: 4,
      },
    ],
  },

  basicWidth: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100,
      step: 0.1,
      unit: "m",
    },
  },

  basicLength: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 300,
      step: 0.1,
      unit: "m",
    },
  },

  basicHeightSide: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 10,
      step: 0.1,
      unit: "m",
    },
  },

  basicAreaPyeong: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100000,
      step: 1,
      unit: "평",
    },
  },

  conAreaPyeong: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100000,
      step: 0.1,
      unit: "평",
    },
  },

  conWidth: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 10000,
      step: 0.1,
      unit: "m",
    },
  },

  conLength: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 10000,
      step: 0.1,
      unit: "m",
    },
  },

  conWidthBay: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100,
      step: 0.1,
      unit: "m",
    },
  },

  conLandOwnershipType: {
    label: "",
    desc: "",
    items: [
      {
        text: "미정",
        value: "미정",
      },
      {
        text: "보유중",
        value: "보유중",
      },
      {
        text: "임차중",
        value: "임차중",
      },
      {
        text: "매입 검토중",
        value: "매입 검토중",
      },
      {
        text: "임차 검토중",
        value: "임차 검토중",
      },
      {
        text: "토지 계약 미정",
        value: "토지 계약 미정",
      },
      {
        text: "토지 계약 준비중",
        value: "토지 계약 준비중",
      },
      {
        text: "토지 계약 완료",
        value: "토지 계약 완료",
      },
    ],
  },

  conLandOwnershipType_V2: {
    label: "",
    desc: "",
    items: [
      {
        text: "토지 소유중",
        value: "소유중",
      },
      {
        text: "토지 임차중",
        value: "임차중",
      },
      {
        text: "토지 계약 준비중",
        value: "계약 준비중",
      },
      {
        text: "미정",
        value: "미정",
      },
    ],
  },

  conFarming: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 농사 중입니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  conFarmingV2: {
    label: "",
    desc: "",
    items: [
      {
        text: "경력 없음",
        value: 0,
      },
      {
        text: "경력 있음",
        value: 1,
      },
      {
        text: "1년 미만",
        value: 2,
      },
      {
        text: "1~5년 미만",
        value: 3,
      },
      {
        text: "5~10년 미만",
        value: 4,
      },
      {
        text: "10~20년 미만",
        value: 5,
      },
      {
        text: "20년 이상",
        value: 6,
      },
    ],
  },

  conFarmmorning: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 팜모닝 사용 중입니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  conExport: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 수출 예정입니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  conUsage: {
    label: "",
    desc: "",
    items: [
      {
        text: "농막하우스",
        value: "농막하우스",
      },
      {
        text: "텃밭/농사하우스",
        value: "텃밭/농사하우스",
      },
      {
        text: "반반하우스",
        value: "반반하우스",
      },
      {
        text: "비가림하우스",
        value: "비가림하우스",
      },
      {
        text: "기타",
        value: "기타",
      },
    ],
  },

  conDate: {
    label: "",
    desc: "",
    items: [],
  },

  conBudget: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100000000000000,
      step: 1,
      unit: "원",
    },
  },

  totalCostAvg: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100000000000000,
      step: 1,
      unit: "원",
    },
  },

  conSupport: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 지원 예정입니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  conSupportType: {
    label: "",
    desc: "",
    items: [
      {
        text: "지원 미정",
        value: "지원 미정",
      },
      {
        text: "보조사업 확정",
        value: "보조사업 확정",
      },
      {
        text: "융자사업 확정",
        value: "융자사업 확정",
      },
      {
        text: "자부담/지원 안함",
        value: "자부담/지원 안함",
      },
      {
        text: "보조사업 지원중",
        value: "보조사업 지원중",
      },
      {
        text: "융자사업 지원중",
        value: "융자사업 지원중",
      },
      {
        text: "보조사업 지원예정",
        value: "보조사업 지원예정",
      },
      {
        text: "융자사업 지원예정",
        value: "융자사업 지원예정",
      },
    ],
  },

  conSupportType_V2: {
    label: "",
    desc: "",
    items: [
      {
        text: "자부담(지원 안함)",
        value: "자부담(지원 안함)",
      },
      {
        text: "보조사업",
        value: "보조사업",
      },
      {
        text: "융자사업",
        value: "융자사업",
      },
      {
        text: "보조+융자사업",
        value: "보조+융자사업",
      },
      {
        text: "미정",
        value: "미정",
      },
    ],
  },

  conSupportType_V3: {
    label: "",
    desc: "",
    items: [
      {
        text: "보조사업",
        value: "보조사업",
      },
      {
        text: "융자사업",
        value: "융자사업",
      },
      {
        text: "보조+융자사업",
        value: "보조+융자사업",
      },
    ],
  },

  conSupportStatus: {
    label: "",
    desc: "",
    items: [
      {
        text: "자부담(지원 안함)",
        value: "자부담(지원 안함)",
      },
      {
        text: "선정됨",
        value: "선정됨",
      },
      {
        text: "지원중",
        value: "지원중",
      },
      {
        text: "지원 예정",
        value: "지원 예정",
      },
    ],
  },

  counselTaken: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 상담 요청합니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  counselMemo: {},

  privacyAgree: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 동의합니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  marketingAgree: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 동의합니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  marketingAgreeDate: {
    label: "",
    desc: "",
    items: [],
  },

  thirdPartyAgrees: {
    label: "",
    desc: "",
    items: [
      {
        text: "그린랩스",
        value: 1,
      },
      {
        text: "파트너",
        value: 2,
      },
    ],
  },

  modelUse: {
    label: "",
    desc: "",
    items: [
      {
        text: "간편견적",
        value: "간편견적",
      },
      {
        text: "수익성분석",
        value: "수익성분석",
      },
    ],
  },

  published: {
    label: "",
    desc: "",
    items: [
      {
        text: "공개",
        value: true,
      },
      {
        text: "비공개",
        value: false,
      },
    ],
  },

  inflowType: {
    label: "",
    desc: "",
    items: [
      {
        text: "직접입력",
        value: "직접입력",
      },
      {
        text: "유선상담",
        value: "유선상담",
      },
      {
        text: "간편견적",
        value: "간편견적",
      },
    ],
  },

  progressStatus: {
    label: "",
    desc: "",
    items: [
      {
        code: PROGRESS_STATUS.PREPARATION,
        value: "준비",
        text: "준비",
        description: "고객이 상담을 준비중인 상태입니다. (상담 요청 사항을 수정할 수 있습니다)",
      },
      {
        code: PROGRESS_STATUS.CONSULTATION_REQUEST,
        value: "상담요청",
        text: "상담요청",
        description: "고객이 상담을 요청한 상태입니다. (상담 요청 사항을 수정할 수 없습니다)",
      },
      {
        code: PROGRESS_STATUS.CONSULTING,
        value: "상담중",
        text: "상담중",
        description: "상담을 진행하는 중입니다.",
      },
      {
        code: PROGRESS_STATUS.DESIGN_ESTIMATE,
        value: "설계/견적중",
        text: "설계/견적중",
        description: "설계와 견적을 진행하는 중입니다.",
      },
      {
        code: PROGRESS_STATUS.CONSULTATION_COMPLETE,
        value: "상담완료",
        text: "상담완료",
        description: "상담 완료 후 계약 대기중입니다.",
      },
      {
        code: PROGRESS_STATUS.CONTRACT,
        value: "계약중",
        text: "계약중",
        description: "계약을 진행하는 중입니다.",
      },
      {
        code: PROGRESS_STATUS.CONTRACT_COMPLETED,
        value: "계약완료",
        text: "계약완료",
        description: "계약 완료 후 시공 대기중입니다.",
      },
      {
        code: PROGRESS_STATUS.CONSTRUCTION,
        value: "시공중",
        text: "시공중",
        description: "시공을 진행하는 중입니다.",
      },
      {
        code: PROGRESS_STATUS.CONSTRUCTION_COMPLETED,
        value: "시공완료",
        text: "시공완료",
        description: "시공을 완료 후 정산 대기중입니다.",
      },
      {
        code: PROGRESS_STATUS.TRANSACTION_SETTLEMENT,
        value: "거래/정산중",
        text: "거래/정산중",
        description: "자재 거래 또는 시공비를 정산하는 중입니다.",
      },
      {
        code: PROGRESS_STATUS.COMPLETED,
        value: "완료",
        text: "완료",
        description: "거래 또는 시공 정산이 성공적으로 마무리된 상태입니다.",
      },
      {
        code: PROGRESS_STATUS.CONSULTATION_STOP,
        value: "종료",
        text: "종료",
        description: "거래나 시공을 하지 못하고 종료된 상태입니다.",
      },
    ],
  },

  transactionMethod: {
    items: [
      {
        code: TRANSACTION_METHOD.UNDECIDED,
        value: "미정",
        text: "미정",
      },
      {
        code: TRANSACTION_METHOD.MATERIALS,
        value: "자재 구입",
        text: "자재 구입",
      },
      {
        code: TRANSACTION_METHOD.MATERIALS_CONSTRUCTION,
        value: "자재+시공",
        text: "자재+시공",
      },
      {
        code: TRANSACTION_METHOD.CONSTRUCTION,
        value: "시공",
        text: "시공",
      },
    ],
  },

  reasonForDiscontinuation: {
    items: [
      {
        code: REASON_FOR_DISCONTINUATION.INCONGRUITY,
        value: "부적합",
        text: "부적합",
        description: "연락을 시도 하지 않았습니다.",
      },
      {
        code: REASON_FOR_DISCONTINUATION.CONTACT_FAILED,
        value: "연락 실패",
        text: "연락 실패",
        description: "연락은 했지만 연결되지 않았습니다.",
      },
      {
        code: REASON_FOR_DISCONTINUATION.COUNSELING_FAILED,
        value: "상담 실패",
        text: "상담 실패",
        description: "연락은 성공했지만, 상담 후 고객이 이탈했습니다.",
      },
      {
        code: REASON_FOR_DISCONTINUATION.DESIGN_AND_ESTIMATE_FAILURE,
        value: "설계/견적 실패",
        text: "설계/견적 실패",
        description: "설계/견적 단계에서 고객이 이탈했습니다.",
      },
      {
        code: REASON_FOR_DISCONTINUATION.CONTRACT_FAILURE,
        value: "계약 실패",
        text: "계약 실패",
        description: "계약이 성사되지 않았습니다.",
      },
      {
        code: REASON_FOR_DISCONTINUATION.CONSTRUCTION_FAILURE,
        value: "시공 실패",
        text: "시공 실패",
        description: "계약은 성공했지만, 시공을 하지 못 했습니다.",
      },
      {
        code: REASON_FOR_DISCONTINUATION.TRANSACTION_SETTLEMENT_FAILED,
        value: "거래/정산 실패",
        text: "거래/정산 실패",
        description: "거래 또는 정산을 하지 못 했습니다.",
      },
    ],
  },

  conSource: {
    items: [
      {
        code: CON_SOURCE.FARMMORNING,
        value: CON_SOURCE.FARMMORNING,
        text: "팜모닝",
      },
      {
        code: CON_SOURCE.COMPANY,
        value: CON_SOURCE.COMPANY,
        text: "업체등록",
      },
    ],
  },
  templateList: {
    F01: [
      { id: 4667, widthBay: [0, 6.9] },
      { id: 4668, widthBay: [7, 7.9] },
      { id: 6306, widthBay: [8, 8.9] },
      { id: 4669, widthBay: [9, 11.9] },
      { id: 6291, widthBay: [12, 14.9] },
      { id: 6295, widthBay: [15] },
    ],
    F03: [
      { id: 6367, widthBay: [0, 4.9] },
      { id: 3188, widthBay: [5, 5.9] },
      { id: 3190, widthBay: [6, 6.9] },
      { id: 183, widthBay: [7, 7.9] },
      { id: 4421, widthBay: [8] },
    ],
    F04: [
      { id: 6320, widthBay: [0, 7.9] },
      { id: 6322, widthBay: [8] },
    ],
    F05: [{ id: 6314, widthBay: [7, 8] }],
  },
} as const;

/**
 * 수익성분석 데이터
 */
export const StartupData: any = {
  published: {
    label: "",
    desc: "",
    items: [
      {
        text: "공개",
        value: true,
      },
      {
        text: "비공개",
        value: false,
      },
    ],
  },

  modelType: {
    label: "",
    desc: "",
    items: [
      {
        text: ProfitConst.modelType.FBN,
        value: ProfitConst.modelType.FBN,
      },
    ],
  },

  fmConsulting: {
    label: "",
    desc: "",
    items: [
      {
        text: "예",
        value: true,
      },
      {
        text: "아니오",
        value: false,
      },
    ],
  },

  tradePricePerKg: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100,
      step: 1,
      unit: "원",
    },
  },

  incomeLevel: {
    label: "",
    desc: "",
    items: [
      {
        text: "Level 0",
        value: "Level 0",
      },
      {
        text: "Level 1",
        value: "Level 1",
      },
      {
        text: "Level 2",
        value: "Level 2",
      },
      {
        text: "Level 3",
        value: "Level 3",
      },
      {
        text: "Level 4",
        value: "Level 4",
      },
    ],
  },

  conBudget: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 100000000000000,
      step: 1,
      unit: "원",
    },
  },

  houseAreaPyeong: {
    label: "",
    desc: "",
    data: {
      min: 0,
      max: 10000,
      step: 1,
      unit: "평",
    },
  },

  farmerTrained: {
    label: "",
    desc: "",
    items: [
      {
        text: "예",
        value: true,
      },
      {
        text: "아니오",
        value: false,
      },
    ],
  },

  privacyAgree: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 동의합니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  marketingAgree: {
    label: "",
    desc: "",
    items: [
      {
        text: "예, 동의합니다.",
        value: true,
      },
      {
        text: "아니오.",
        value: false,
      },
    ],
  },

  marketingAgreeDate: {
    label: "",
    desc: "",
    items: [],
  },

  inflowType: {
    label: "",
    desc: "",
    items: [
      {
        text: "직접입력",
        value: "직접입력",
      },
      {
        text: "유선상담",
        value: "유선상담",
      },
      {
        text: "수익성분석",
        value: "수익성분석",
      },
    ],
  },
} as const;

export const designFacilityData = [
  {
    F01: [
      {
        title: "외부 피복",
        category2: DESIGN_ITEM_CATEGORY3.COVER_OUTER,
        selected: true,
        children: [
          {
            code: DesignItemNumber.cover.outerCover.cover2,
            value: "비닐+차광망",
            selected: true,
          },
          {
            code: DesignItemNumber.cover.outerCover.cover1,
            value: "차광필름",
            selected: false,
          },
          {
            code: DesignItemNumber.cover.outerCover.cover4,
            value: "텐텐지+솜+비닐+차광망",
            selected: false,
          },
          {
            code: DesignItemNumber.cover.outerCover.cover5,
            value: "텐텐지+비닐+보온덮개+비닐+차광망",
            selected: false,
          },
        ],
      },
      {
        title: "측면 개폐",
        category2: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE,
        selected: true,
        children: [
          {
            code: DesignItemNumber.switch.sideswitch.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.switch.sideswitch.switcher_manual,
            value: "수동 개폐",
            selected: false,
          },
        ],
      },
      {
        title: "외부 배기",
        category2: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST,
        selected: true,
        children: [
          {
            code: DesignItemNumber.ventexhaust.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.ventexhaust.vent_exhaust_roof_fan_manual,
            value: "지붕 환풍구",
            selected: false,
          },
          {
            code: DesignItemNumber.ventexhaust.vent_exhaust_fan,
            value: "배기팬",
            selected: false,
          },
        ],
      },
      {
        title: "창문",
        category2: DESIGN_ITEM_CATEGORY3.WINDOW,
        selected: true,
        children: [
          {
            code: DesignItemNumber.window.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.window.window_sash_frame,
            value: "샷시 창문",
            selected: true,
          },
          {
            code: DesignItemNumber.window.window_hinged,
            value: "여닫이 창문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "수량",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.WINDOW,
            isQuantity: true,
            min: 1,
            max: 100,
            step: 1,
            unit: "개",
          },
        ],
      },
      {
        title: "출입문 앞면",
        category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT, // category3 으로 수정됨
        selected: true,
        children: [
          {
            code: DesignItemNumber.frame.gate_front.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.frame.gate_front.sliding,
            value: "미닫이문",
            selected: true,
          },
          {
            code: DesignItemNumber.frame.gate_front.hinged,
            value: "여닫이문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "문짝 개수",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
            isQuantity: true,
            min: 1,
            max: 2,
            step: 1,
            unit: "짝",
          },
        ],
      },
      {
        title: "출입문 뒷면",
        category2: DESIGN_ITEM_CATEGORY3.GATE_BACK, // category3 으로 수정됨
        selected: true,
        children: [
          {
            code: DesignItemNumber.frame.gate_back.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.frame.gate_back.sliding,
            value: "미닫이문",
            selected: false,
          },
          {
            code: DesignItemNumber.frame.gate_back.hinged,
            value: "여닫이문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "문짝 개수",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
            isQuantity: true,
            min: 1,
            max: 2,
            step: 1,
            unit: "짝",
          },
        ],
      },
    ],
  },
  {
    F03: [
      {
        title: "외부 피복",
        category2: DESIGN_ITEM_CATEGORY3.COVER_OUTER,
        selected: true,
        children: [
          {
            code: DesignItemNumber.cover.outerCover.vinyl,
            value: "비닐",
            selected: true,
          },
          {
            code: DesignItemNumber.cover.outerCover.cover2,
            value: "비닐+차광망",
            selected: false,
          },
        ],
      },
      {
        title: "내부 피복",
        category2: DESIGN_ITEM_CATEGORY3.COVER_INNER,
        selected: true,
        children: [
          {
            code: DesignItemNumber.cover.innerCover.vinyl,
            value: "비닐",
            selected: true,
          },
          {
            code: DesignItemNumber.cover.innerCover.vinyl_nonwoven,
            value: "비닐+부직포",
            selected: false,
          },
          {
            code: DesignItemNumber.cover.innerCover.vinyl_quilting,
            value: "비닐+다겹커튼지",
            selected: false,
          },
        ],
      },
      {
        title: "측면 개폐",
        category2: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE,
        selected: true,
        children: [
          {
            code: DesignItemNumber.switch.sideswitch.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.switch.sideswitch.switcher_manual,
            value: "수동 개폐",
            selected: true,
          },
          {
            code: DesignItemNumber.switch.sideswitch.switcher_power,
            value: "동력 개폐",
            selected: false,
          },
        ],
      },
      {
        title: "지붕(천창) 개폐",
        category2: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF,
        selected: true,
        children: [
          {
            code: DesignItemNumber.skylight.roofswitch.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.skylight.roofswitch.switcher_power,
            value: "동력 개폐",
            selected: false,
          },
          {
            code: DesignItemNumber.skylight.roofswitch.skylight_frame_half,
            value: "반천창 동력 개폐",
            selected: false,
          },
        ],
      },
      {
        title: "외부 배기",
        category2: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST,
        selected: true,
        children: [
          {
            code: DesignItemNumber.ventexhaust.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.ventexhaust.vent_exhaust_fan,
            value: "배기팬",
            selected: false,
          },
        ],
      },
      {
        title: "내부 배기",
        category2: DESIGN_ITEM_CATEGORY3.VENT_INSIDE,
        selected: true,
        children: [
          {
            code: DesignItemNumber.ventinside.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.ventinside.vent_inside_air_flow_fan,
            value: "공기유동팬",
            selected: false,
          },
        ],
      },
      {
        title: "출입문 앞면",
        category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT, // category3로 수정
        selected: true,
        children: [
          {
            code: DesignItemNumber.frame.gate_front.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.frame.gate_front.sliding,
            value: "미닫이문",
            selected: true,
          },
          {
            code: DesignItemNumber.frame.gate_front.hinged,
            value: "여닫이문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "문짝 개수",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
            isQuantity: true,
            min: 1,
            max: 2,
            step: 1,
            unit: "짝",
          },
        ],
      },
      {
        title: "출입문 뒷면",
        category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
        selected: true,
        children: [
          {
            code: DesignItemNumber.frame.gate_back.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.frame.gate_back.sliding,
            value: "미닫이문",
            selected: true,
          },
          {
            code: DesignItemNumber.frame.gate_back.hinged,
            value: "여닫이문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "문짝 개수",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
            isQuantity: true,
            min: 1,
            max: 2,
            step: 1,
            unit: "짝",
          },
        ],
      },
    ],
  },
  {
    F04: [
      {
        title: "외부 피복",
        category2: DESIGN_ITEM_CATEGORY3.COVER_OUTER,
        selected: true,
        children: [
          {
            code: DesignItemNumber.cover.outerCover.vinyl,
            value: "비닐",
            selected: true,
          },
        ],
      },
      {
        title: "내부 피복",
        category2: DESIGN_ITEM_CATEGORY3.COVER_INNER,
        selected: true,
        children: [
          {
            code: DesignItemNumber.cover.innerCover.vinyl,
            value: "비닐",
            selected: true,
          },
        ],
      },
      {
        title: "내부 수평커튼",
        category2: DESIGN_ITEM_CATEGORY3.CURCOVER,
        selected: true,
        children: [
          {
            code: DesignItemNumber.curcover.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.curcover.quilting,
            value: "1중 다겹커튼지",
            selected: false,
          },
          {
            code: DesignItemNumber.curcover.quilting_shadenet,
            value: "1중 다겹커튼지 + 2중 차광망",
            selected: false,
          },
          {
            code: DesignItemNumber.curcover.quilting_screen,
            value: "1중 다겹커튼지 + 2중 스크린",
            selected: false,
          },
          {
            code: DesignItemNumber.curcover.quilting_screen_screen,
            value: "1중 다겹커튼지 + 2중 스크린 + 3중 스크린",
            selected: false,
          },
        ],
      },
      {
        title: "측면 개폐",
        category2: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE,
        selected: true,
        children: [
          {
            code: DesignItemNumber.switch.sideswitch.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.switch.sideswitch.switcher_power,
            value: "동력 개폐",
            selected: true,
          },
        ],
      },
      {
        title: "지붕(천창) 개폐",
        category2: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF,
        selected: true,
        children: [
          {
            code: DesignItemNumber.skylight.roofswitch.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.skylight.roofswitch.switcher_power,
            value: "동력 개폐",
            selected: true,
          },
          {
            code: DesignItemNumber.skylight.roofswitch.skylight_frame_half,
            value: "반천창 동력 개폐",
            selected: false,
          },
          {
            code: DesignItemNumber.skylight.roofswitch.skylight_frame_rackpinion_way_both,
            value: "랙피니언 개폐",
            selected: false,
          },
        ],
      },
      {
        title: "외부 배기",
        category2: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST,
        selected: true,
        children: [
          {
            code: DesignItemNumber.ventexhaust.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.ventexhaust.vent_exhaust_fan,
            value: "배기팬",
            selected: true,
          },
        ],
      },
      {
        title: "내부 배기",
        category2: DESIGN_ITEM_CATEGORY3.VENT_INSIDE,
        selected: true,
        children: [
          {
            code: DesignItemNumber.ventinside.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.ventinside.vent_inside_air_flow_fan,
            value: "공기유동팬",
            selected: false,
          },
        ],
      },
      {
        title: "출입문 앞면",
        category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
        selected: true,
        children: [
          {
            code: DesignItemNumber.frame.gate_front.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.frame.gate_front.sliding,
            value: "미닫이문",
            selected: true,
          },
          {
            code: DesignItemNumber.frame.gate_front.hinged,
            value: "여닫이문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "설치 동수",
            key: "num2",
            category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
            isQuantity: true,
            min: 1,
            max: 100,
            step: 1,
            unit: "동",
          },
          {
            title: "문짝 개수",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
            isQuantity: true,
            min: 1,
            max: 2,
            step: 1,
            unit: "짝",
          },
        ],
      },
      {
        title: "출입문 뒷면",
        category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
        selected: true,
        children: [
          {
            code: DesignItemNumber.frame.gate_back.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.frame.gate_back.sliding,
            value: "미닫이문",
            selected: false,
          },
          {
            code: DesignItemNumber.frame.gate_back.hinged,
            value: "여닫이문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "설치 동수",
            key: "num2",
            category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
            isQuantity: true,
            min: 1,
            max: 100,
            step: 1,
            unit: "동",
          },
          {
            title: "문짝 개수",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
            isQuantity: true,
            min: 1,
            max: 2,
            step: 1,
            unit: "짝",
          },
        ],
      },
    ],
  },
  {
    F05: [
      {
        title: "외부 피복",
        category2: DESIGN_ITEM_CATEGORY3.COVER_OUTER,
        selected: true,
        children: [
          {
            code: DesignItemNumber.cover.outerCover.vinyl,
            value: "비닐",
            selected: true,
          },
        ],
      },
      {
        title: "내부 수평커튼",
        category2: DESIGN_ITEM_CATEGORY3.COVER_INNER,
        selected: true,
        children: [
          {
            code: DesignItemNumber.curcover.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.curcover.quilting,
            value: "1중 다겹커튼지",
            selected: true,
          },
          {
            code: DesignItemNumber.curcover.quilting_screen,
            value: "1중 다겹커튼지 + 2중 스크린",
            selected: false,
          },
          {
            code: DesignItemNumber.curcover.quilting_screen_screen,
            value: "1중 다겹커튼지 + 2중 스크린 + 3중 스크린",
            selected: false,
          },
        ],
      },
      {
        title: "측면 개폐",
        category2: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE,
        selected: true,
        children: [
          {
            code: DesignItemNumber.switch.sideswitch.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.switch.sideswitch.switcher_power,
            value: "동력 개폐",
            selected: false,
          },
        ],
      },
      {
        title: "지붕(천창) 개폐",
        category2: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF,
        selected: true,
        children: [
          {
            code: DesignItemNumber.skylight.roofswitch.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.skylight.roofswitch.switcher_power,
            value: "동력 개폐",
            selected: true,
          },
          {
            code: DesignItemNumber.skylight.roofswitch.skylight_frame_half,
            value: "반천창 동력 개폐",
            selected: false,
          },
          {
            code: DesignItemNumber.skylight.roofswitch.skylight_frame_rackpinion_way_both,
            value: "랙피니언 개폐",
            selected: false,
          },
        ],
      },
      {
        title: "외부 배기",
        category2: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST,
        selected: true,
        children: [
          {
            code: DesignItemNumber.ventexhaust.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.ventexhaust.vent_exhaust_fan,
            value: "배기팬",
            selected: true,
          },
        ],
      },
      {
        title: "내부 배기",
        category2: DESIGN_ITEM_CATEGORY3.VENT_INSIDE,
        selected: true,
        children: [
          {
            code: DesignItemNumber.ventinside.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.ventinside.vent_inside_air_flow_fan,
            value: "공기유동팬",
            selected: false,
          },
        ],
      },
      {
        title: "출입문 앞면",
        category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
        selected: true,
        children: [
          {
            code: DesignItemNumber.frame.gate_front.none,
            value: "없음",
            selected: false,
          },
          {
            code: DesignItemNumber.frame.gate_front.sliding,
            value: "미닫이문",
            selected: true,
          },
          {
            code: DesignItemNumber.frame.gate_front.hinged,
            value: "여닫이문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "설치 동수",
            key: "num2",
            category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
            isQuantity: true,
            min: 1,
            max: 100,
            step: 1,
            unit: "동",
          },
          {
            title: "문짝 개수",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
            isQuantity: true,
            min: 1,
            max: 2,
            step: 1,
            unit: "짝",
          },
        ],
      },
      {
        title: "출입문 뒷면",
        category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
        selected: true,
        children: [
          {
            code: DesignItemNumber.frame.gate_back.none,
            value: "없음",
            selected: true,
          },
          {
            code: DesignItemNumber.frame.gate_back.sliding,
            value: "미닫이문",
            selected: false,
          },
          {
            code: DesignItemNumber.frame.gate_back.hinged,
            value: "여닫이문",
            selected: false,
          },
        ],
        subChildren: [
          {
            title: "설치 동수",
            key: "num2",
            category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
            isQuantity: true,
            min: 1,
            max: 100,
            step: 1,
            unit: "동",
          },
          {
            title: "문짝 개수",
            key: "num1",
            category2: DESIGN_ITEM_CATEGORY3.GATE_BACK,
            isQuantity: true,
            min: 1,
            max: 2,
            step: 1,
            unit: "짝",
          },
        ],
      },
    ],
  },
];

export const facilityData: any = {
  F01: [
    {
      text: "건축 시설",
      value: DESIGN_ITEM_CATEGORY1.ARCHITECTURE,
      selected: true,
      category2: [
        // {
        //   text: "기초",
        //   value: DESIGN_ITEM_CATEGORY2.FOUNDATION,
        //   code: DesignItemNumber.foundation.foundation,
        //   selected: false,
        // },
        {
          text: "골조",
          value: DESIGN_ITEM_CATEGORY2.FRAME,
          code: DesignItemNumber.frame.frame,
          selected: true,
          category3: [
            {
              text: "출입문 앞면",
              value: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
              items: [
                {
                  text: "없음",
                  code: DesignItemNumber.frame.gate_front.none,
                  selected: false,
                },
                {
                  text: "미닫이문",
                  code: DesignItemNumber.frame.gate_front.sliding,
                  selected: true,
                },
                {
                  text: "여닫이문",
                  code: DesignItemNumber.frame.gate_front.hinged,
                  selected: false,
                },
              ],
              quantity: [{ text: "문짝 개수", key: "num1", min: 1, max: 2, step: 1, unit: "짝" }],
            },
            {
              text: "출입문 뒷면",
              value: DESIGN_ITEM_CATEGORY3.GATE_BACK,
              items: [
                {
                  text: "없음",
                  code: DesignItemNumber.frame.gate_back.none,
                  selected: true,
                },
                {
                  text: "미닫이문",
                  code: DesignItemNumber.frame.gate_back.sliding,
                  selected: false,
                },
                {
                  text: "여닫이문",
                  code: DesignItemNumber.frame.gate_back.hinged,
                  selected: false,
                },
              ],
              quantity: [{ text: "문짝 개수", key: "num1", min: 1, max: 2, step: 1, unit: "짝" }],
            },
          ],
        },
        {
          text: "피복",
          value: DESIGN_ITEM_CATEGORY2.COVER,
          code: DesignItemNumber.cover.cover,
          selected: true,
          category3: [
            {
              text: "외부 피복",
              value: DESIGN_ITEM_CATEGORY3.COVER_OUTER,
              items: [
                {
                  code: DesignItemNumber.cover.outerCover.cover2,
                  text: "비닐+차광망",
                  selected: true,
                },
                {
                  code: DesignItemNumber.cover.outerCover.cover1,
                  text: "차광필름",
                  selected: false,
                },
                {
                  code: DesignItemNumber.cover.outerCover.cover4,
                  text: "텐텐지+솜+비닐+차광망",
                  selected: false,
                },
                {
                  code: DesignItemNumber.cover.outerCover.cover5,
                  text: "텐텐지+비닐+보온덮개+비닐+차광망",
                  selected: false,
                },
              ],
            },
          ],
        },
        {
          text: "개폐",
          value: DESIGN_ITEM_CATEGORY2.SWITCH,
          code: DesignItemNumber.switch.sideswitch.sideswitch,
          selected: false,
          category3: [
            {
              text: "측면 개폐",
              value: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE,
              items: [
                {
                  code: DesignItemNumber.switch.sideswitch.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.switch.sideswitch.switcher_manual,
                  text: "수동 개폐",
                  selected: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "환기 시설",
      value: DESIGN_ITEM_CATEGORY1.VENT,
      selected: true,
      category2: [
        {
          text: "외부 배기",
          value: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST,
          category3: [
            {
              text: "외부 배기",
              value: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST,
              items: [
                {
                  code: DesignItemNumber.ventexhaust.none,
                  text: "없음",
                  selected: true,
                },
                {
                  code: DesignItemNumber.ventexhaust.vent_exhaust_fan,
                  text: "배기팬",
                  selected: false,
                },
                {
                  code: DesignItemNumber.ventexhaust.vent_exhaust_roof_fan_manual,
                  text: "지붕 환풍구",
                  selected: false,
                },
              ],
            },
          ],
        },
        {
          text: "샷시 창문",
          value: DESIGN_ITEM_CATEGORY2.SASH_WINDOW,
          category3: [
            {
              text: "창문",
              value: DESIGN_ITEM_CATEGORY3.WINDOW,
              items: [
                {
                  code: DesignItemNumber.window.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.window.window_sash_frame,
                  text: "샷시 창문",
                  selected: true,
                },
                {
                  code: DesignItemNumber.window.window_hinged,
                  text: "여닫이 창문",
                  selected: false,
                },
              ],
              quantity: [{ text: "수량", key: "num1", min: 1, max: 100, step: 1, unit: "개" }],
            },
          ],
        },
      ],
    },
    {
      text: "관수 설비",
      value: DESIGN_ITEM_CATEGORY1.WATERING,
      selected: false,
      category2: [
        {
          text: "포그 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_FOG,
          code: DesignItemNumber.watering_fog.watering_fog,
          selected: false,
        },
        {
          text: "스프링클러 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SPRINKLER,
          code: DesignItemNumber.watering_sprinkler.watering_sprinkler,
          selected: false,
        },
        {
          text: "점적 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_DRIP,
          code: DesignItemNumber.watering_drip.watering_drip,
          selected: false,
        },
        {
          text: "수막 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SCREEN,
          code: DesignItemNumber.watering_screen.watering_screen,
          selected: false,
        },
      ],
    },
    {
      text: "양액 설비",
      value: DESIGN_ITEM_CATEGORY1.HYDROPONICS,
      selected: false,
      category2: [
        {
          text: "고형배지 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_SUBSTRATE_CULTURE,
          code: DesignItemNumber.hydroponics_substrate_culture.hydroponics_substrate_culture,
          selected: false,
        },
        {
          text: "NFT 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_NFT,
          code: DesignItemNumber.hydroponics_nft.hydroponics_nft,
          selected: false,
        },
      ],
    },
    {
      text: "냉난방 설비",
      value: DESIGN_ITEM_CATEGORY1.TEMPERATURE,
      selected: false,
      category2: [
        {
          text: "온수 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_WATER,
          code: DesignItemNumber.heating_warm_water.heating_warm_water,
          selected: false,
        },
        {
          text: "증기 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_STEAM,
          code: DesignItemNumber.heating_steam.heating_steam,
          selected: false,
        },
        {
          text: "온풍 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_AIR,
          code: DesignItemNumber.heating_warm_air.heating_warm_air,
          selected: false,
        },
        {
          text: "직열튜브 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_DIRECT_TUBE,
          code: DesignItemNumber.heating_direct_tube.heating_direct_tube,
          selected: false,
        },
        {
          text: "지열히트펌프",
          value: DESIGN_ITEM_CATEGORY2.HEATING_GROUND_PUMP,
          code: DesignItemNumber.heating_ground_pump.heating_ground_pump,
          selected: false,
        },
        {
          text: "물탱크 칠러",
          value: DESIGN_ITEM_CATEGORY2.WATER_TANK_CHILLER,
          code: DesignItemNumber.water_tank_chiller.water_tank_chiller,
          selected: false,
        },
        {
          text: "에어컨",
          value: DESIGN_ITEM_CATEGORY2.AIRCONDITIONER,
          code: DesignItemNumber.airconditioner.airconditioner,
          selected: false,
        },
      ],
    },
    {
      text: "환경 설비",
      value: DESIGN_ITEM_CATEGORY1.ENVIRONMENT,
      selected: false,
      category2: [
        {
          text: "복합환경제어 설비",
          value: DESIGN_ITEM_CATEGORY2.ENVIRONMENT,
          code: DesignItemNumber.environment.environment,
          selected: false,
        },
        {
          text: "CO2 설비",
          value: DESIGN_ITEM_CATEGORY2.CO2,
          code: DesignItemNumber.co2.co2,
          selected: false,
        },
        {
          text: "자동 방제기",
          value: DESIGN_ITEM_CATEGORY2.AUTOSPRAY,
          code: DesignItemNumber.autospray.autospray,
          selected: false,
        },
      ],
    },
    {
      text: "기타 설비",
      value: DESIGN_ITEM_CATEGORY1.OTHER,
      selected: false,
      category2: [
        {
          text: "작업부/작업동",
          value: DESIGN_ITEM_CATEGORY2.WORKROOM,
          code: DesignItemNumber.workroom.workroom,
          selected: false,
        },
        {
          text: "선반/균상다이",
          value: DESIGN_ITEM_CATEGORY2.RACK,
          code: DesignItemNumber.rack.rack,
          selected: false,
        },
        {
          text: "운반 레일",
          value: DESIGN_ITEM_CATEGORY2.RAIL,
          code: DesignItemNumber.rail.rail,
          selected: false,
        },
        {
          text: "지반평탄화/배수로",
          value: DESIGN_ITEM_CATEGORY2.GROUND_FLAT,
          code: DesignItemNumber.ground_flat.ground_flat,
          selected: false,
        },
        {
          text: "바닥 콘크리트",
          value: DESIGN_ITEM_CATEGORY2.CONCRETE,
          code: DesignItemNumber.concrete.concrete,
          selected: false,
        },
        {
          text: "화장실/정화조/관정",
          value: DESIGN_ITEM_CATEGORY2.WASHROOM,
          code: DesignItemNumber.washroom.washroom,
          selected: false,
        },
        {
          text: "컨테이너",
          value: DESIGN_ITEM_CATEGORY2.CONTAINER,
          code: DesignItemNumber.container.container,
          selected: false,
        },
      ],
    },
  ],
  F03: [
    {
      text: "건축 시설",
      value: DESIGN_ITEM_CATEGORY1.ARCHITECTURE,
      selected: true,
      category2: [
        // {
        //   text: "기초",
        //   value: DESIGN_ITEM_CATEGORY2.FOUNDATION,
        //   code: DesignItemNumber.foundation.foundation,
        //   selected: false,
        // },
        {
          text: "골조",
          value: DESIGN_ITEM_CATEGORY2.FRAME,
          code: DesignItemNumber.frame.frame,
          selected: true,
          category3: [
            {
              text: "출입문 앞면",
              value: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
              items: [
                {
                  text: "없음",
                  code: DesignItemNumber.frame.gate_front.none,
                  selected: false,
                },
                {
                  text: "미닫이문",
                  code: DesignItemNumber.frame.gate_front.sliding,
                  selected: true,
                },
                {
                  text: "여닫이문",
                  code: DesignItemNumber.frame.gate_front.hinged,
                  selected: false,
                },
              ],
              quantity: [{ text: "문짝 개수", key: "num1", min: 1, max: 2, step: 1, unit: "짝" }],
            },
            {
              text: "출입문 뒷면",
              value: DESIGN_ITEM_CATEGORY3.GATE_BACK,
              items: [
                {
                  text: "없음",
                  code: DesignItemNumber.frame.gate_back.none,
                  selected: false,
                },
                {
                  text: "미닫이문",
                  code: DesignItemNumber.frame.gate_back.sliding,
                  selected: true,
                },
                {
                  text: "여닫이문",
                  code: DesignItemNumber.frame.gate_back.hinged,
                  selected: false,
                },
              ],
              quantity: [{ text: "문짝 개수", key: "num1", min: 1, max: 2, step: 1, unit: "짝" }],
            },
          ],
        },
        {
          text: "피복",
          value: DESIGN_ITEM_CATEGORY2.COVER,
          code: DesignItemNumber.cover.cover,
          selected: true,
          category3: [
            {
              text: "외부 피복",
              value: DESIGN_ITEM_CATEGORY3.COVER_OUTER,
              items: [
                {
                  code: DesignItemNumber.cover.outerCover.vinyl,
                  text: "비닐",
                  selected: true,
                },
                {
                  code: DesignItemNumber.cover.outerCover.cover2,
                  text: "비닐+차광망",
                  selected: false,
                },
              ],
            },
            {
              text: "내부 피복",
              value: DESIGN_ITEM_CATEGORY3.COVER_INNER,
              items: [
                {
                  code: DesignItemNumber.cover.innerCover.vinyl,
                  text: "비닐",
                  selected: true,
                },
                {
                  code: DesignItemNumber.cover.innerCover.vinyl_nonwoven,
                  text: "비닐+부직포",
                  selected: false,
                },
                {
                  code: DesignItemNumber.cover.innerCover.vinyl_quilting,
                  text: "비닐+다겹커튼지",
                  selected: false,
                },
              ],
            },
          ],
        },
        {
          text: "개폐",
          value: DESIGN_ITEM_CATEGORY2.SWITCH,
          code: DesignItemNumber.switch.sideswitch.sideswitch,
          selected: true,
          category3: [
            {
              text: "측면 개폐",
              value: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE,
              items: [
                {
                  code: DesignItemNumber.switch.sideswitch.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.switch.sideswitch.switcher_manual,
                  text: "수동 개폐",
                  selected: true,
                },
                {
                  code: DesignItemNumber.switch.sideswitch.switcher_power,
                  text: "동력 개폐",
                  selected: false,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "추가 시설",
      value: DESIGN_ITEM_CATEGORY1.ADD,
      selected: false,
      category2: [
        {
          text: "지붕(천창) 개폐",
          value: DESIGN_ITEM_CATEGORY2.SKYLIGHT,
          code: DesignItemNumber.skylight.roofswitch.roofswitch,
          selected: false,
          category3: [
            {
              text: "지붕(천창) 개폐",
              value: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF,
              items: [
                {
                  code: DesignItemNumber.skylight.roofswitch.none,
                  text: "없음",
                  selected: true,
                },
                {
                  code: DesignItemNumber.skylight.roofswitch.switcher_power,
                  text: "동력 개폐",
                  selected: false,
                },
                {
                  code: DesignItemNumber.skylight.roofswitch.skylight_frame_half,
                  text: "반천창 동력 개폐",
                  selected: false,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "환기 시설",
      value: DESIGN_ITEM_CATEGORY1.VENT,
      selected: false,
      category2: [
        {
          text: "외부 배기",
          value: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST,
          category3: [
            {
              text: "외부 배기",
              value: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST,
              items: [
                {
                  code: DesignItemNumber.ventexhaust.none,
                  text: "없음",
                  selected: true,
                },
                {
                  code: DesignItemNumber.ventexhaust.vent_exhaust_fan,
                  text: "배기팬",
                  selected: false,
                },
                // {
                //   code: DesignItemNumber.ventexhaust.vent_exhaust_roof_fan_manual,
                //   text: "지붕 환풍구",
                //   selected: false,
                // },
              ],
            },
          ],
        },
        {
          text: "내부 환기",
          value: DESIGN_ITEM_CATEGORY2.VENT_INSIDE,
          selected: false,
          category3: [
            {
              text: "내부 환기",
              value: DESIGN_ITEM_CATEGORY3.VENT_INSIDE,
              items: [
                {
                  code: DesignItemNumber.ventinside.none,
                  text: "없음",
                  selected: true,
                },
                {
                  code: DesignItemNumber.ventinside.vent_inside_air_flow_fan,
                  text: "공기유동팬",
                  selected: false,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "관수 설비",
      value: DESIGN_ITEM_CATEGORY1.WATERING,
      selected: false,
      category2: [
        {
          text: "포그 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_FOG,
          code: DesignItemNumber.watering_fog.watering_fog,
          selected: false,
        },
        {
          text: "스프링클러 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SPRINKLER,
          code: DesignItemNumber.watering_sprinkler.watering_sprinkler,
          selected: false,
        },
        {
          text: "점적 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_DRIP,
          code: DesignItemNumber.watering_drip.watering_drip,
          selected: false,
        },
        {
          text: "수막 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SCREEN,
          code: DesignItemNumber.watering_screen.watering_screen,
          selected: false,
        },
      ],
    },
    {
      text: "양액 설비",
      value: DESIGN_ITEM_CATEGORY1.HYDROPONICS,
      selected: false,
      category2: [
        {
          text: "고형배지 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_SUBSTRATE_CULTURE,
          code: DesignItemNumber.hydroponics_substrate_culture.hydroponics_substrate_culture,
          selected: false,
        },
        {
          text: "NFT 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_NFT,
          code: DesignItemNumber.hydroponics_nft.hydroponics_nft,
          selected: false,
        },
      ],
    },
    {
      text: "냉난방 설비",
      value: DESIGN_ITEM_CATEGORY1.TEMPERATURE,
      selected: false,
      category2: [
        {
          text: "온수 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_WATER,
          code: DesignItemNumber.heating_warm_water.heating_warm_water,
          selected: false,
        },
        {
          text: "증기 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_STEAM,
          code: DesignItemNumber.heating_steam.heating_steam,
          selected: false,
        },
        {
          text: "온풍 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_AIR,
          code: DesignItemNumber.heating_warm_air.heating_warm_air,
          selected: false,
        },
        {
          text: "직열튜브 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_DIRECT_TUBE,
          code: DesignItemNumber.heating_direct_tube.heating_direct_tube,
          selected: false,
        },
        {
          text: "지열히트펌프",
          value: DESIGN_ITEM_CATEGORY2.HEATING_GROUND_PUMP,
          code: DesignItemNumber.heating_ground_pump.heating_ground_pump,
          selected: false,
        },
        {
          text: "물탱크 칠러",
          value: DESIGN_ITEM_CATEGORY2.WATER_TANK_CHILLER,
          code: DesignItemNumber.water_tank_chiller.water_tank_chiller,
          selected: false,
        },
        {
          text: "에어컨",
          value: DESIGN_ITEM_CATEGORY2.AIRCONDITIONER,
          code: DesignItemNumber.airconditioner.airconditioner,
          selected: false,
        },
      ],
    },
    {
      text: "환경 설비",
      value: DESIGN_ITEM_CATEGORY1.ENVIRONMENT,
      selected: false,
      category2: [
        {
          text: "복합환경제어 설비",
          value: DESIGN_ITEM_CATEGORY2.ENVIRONMENT,
          code: DesignItemNumber.environment.environment,
          selected: false,
        },
        {
          text: "CO2 설비",
          value: DESIGN_ITEM_CATEGORY2.CO2,
          code: DesignItemNumber.co2.co2,
          selected: false,
        },
        {
          text: "자동 방제기",
          value: DESIGN_ITEM_CATEGORY2.AUTOSPRAY,
          code: DesignItemNumber.autospray.autospray,
          selected: false,
        },
      ],
    },
    {
      text: "기타 설비",
      value: DESIGN_ITEM_CATEGORY1.OTHER,
      selected: false,
      category2: [
        {
          text: "작업부/작업동",
          value: DESIGN_ITEM_CATEGORY2.WORKROOM,
          code: DesignItemNumber.workroom.workroom,
          selected: false,
        },
        {
          text: "선반/균상다이",
          value: DESIGN_ITEM_CATEGORY2.RACK,
          code: DesignItemNumber.rack.rack,
          selected: false,
        },
        {
          text: "운반 레일",
          value: DESIGN_ITEM_CATEGORY2.RAIL,
          code: DesignItemNumber.rail.rail,
          selected: false,
        },
        {
          text: "지반평탄화/배수로",
          value: DESIGN_ITEM_CATEGORY2.GROUND_FLAT,
          code: DesignItemNumber.ground_flat.ground_flat,
          selected: false,
        },
        {
          text: "바닥 콘크리트",
          value: DESIGN_ITEM_CATEGORY2.CONCRETE,
          code: DesignItemNumber.concrete.concrete,
          selected: false,
        },
        {
          text: "화장실/정화조/관정",
          value: DESIGN_ITEM_CATEGORY2.WASHROOM,
          code: DesignItemNumber.washroom.washroom,
          selected: false,
        },
        {
          text: "컨테이너",
          value: DESIGN_ITEM_CATEGORY2.CONTAINER,
          code: DesignItemNumber.container.container,
          selected: false,
        },
      ],
    },
  ],
  F04: [
    {
      text: "건축 시설",
      value: DESIGN_ITEM_CATEGORY1.ARCHITECTURE,
      selected: true,
      category2: [
        {
          text: "기초",
          value: DESIGN_ITEM_CATEGORY2.FOUNDATION,
          code: DesignItemNumber.foundation.foundation,
          selected: true,
        },
        {
          text: "골조",
          value: DESIGN_ITEM_CATEGORY2.FRAME,
          code: DesignItemNumber.frame.frame,
          selected: true,
          category3: [
            {
              text: "출입문 앞면",
              value: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
              items: [
                {
                  text: "없음",
                  code: DesignItemNumber.frame.gate_front.none,
                  selected: false,
                },
                {
                  text: "미닫이문",
                  code: DesignItemNumber.frame.gate_front.sliding,
                  selected: true,
                },
                {
                  text: "여닫이문",
                  code: DesignItemNumber.frame.gate_front.hinged,
                  selected: false,
                },
              ],
              quantity: [
                { text: "설치 동수", key: "num2", min: 1, max: 100, step: 1, unit: "동" },
                { text: "문짝 개수", key: "num1", min: 1, max: 2, step: 1, unit: "짝" },
              ],
            },
            {
              text: "출입문 뒷면",
              value: DESIGN_ITEM_CATEGORY3.GATE_BACK,
              items: [
                {
                  text: "없음",
                  code: DesignItemNumber.frame.gate_back.none,
                  selected: true,
                },
                {
                  text: "미닫이문",
                  code: DesignItemNumber.frame.gate_back.sliding,
                  selected: false,
                },
                {
                  text: "여닫이문",
                  code: DesignItemNumber.frame.gate_back.hinged,
                  selected: false,
                },
              ],
              quantity: [
                { text: "설치 동수", key: "num2", min: 1, max: 100, step: 1, unit: "동" },
                { text: "문짝 개수", key: "num1", min: 1, max: 2, step: 1, unit: "짝" },
              ],
            },
          ],
        },
        {
          text: "피복",
          value: DESIGN_ITEM_CATEGORY2.COVER,
          code: DesignItemNumber.cover.cover,
          selected: true,
          category3: [
            {
              text: "외부 피복",
              value: DESIGN_ITEM_CATEGORY3.COVER_OUTER,
              items: [
                {
                  code: DesignItemNumber.cover.outerCover.vinyl,
                  text: "비닐",
                  selected: true,
                },
              ],
            },
          ],
        },
        {
          text: "개폐",
          value: DESIGN_ITEM_CATEGORY2.SWITCH,
          code: DesignItemNumber.switch.sideswitch.sideswitch,
          selected: true,
          category3: [
            {
              text: "측면 개폐",
              value: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE,
              items: [
                {
                  code: DesignItemNumber.switch.sideswitch.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.switch.sideswitch.switcher_power,
                  text: "동력 개폐",
                  selected: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "추가 시설",
      value: DESIGN_ITEM_CATEGORY1.ADD,
      selected: true,
      category2: [
        {
          text: "수평 커튼",
          value: DESIGN_ITEM_CATEGORY2.CURTAIN,
          selected: false,
          category3: [
            {
              text: "수평 커튼",
              value: DESIGN_ITEM_CATEGORY3.CURCOVER,
              items: [
                {
                  code: DesignItemNumber.curcover.none,
                  text: "없음",
                  selected: true,
                },
                {
                  code: DesignItemNumber.curcover.quilting,
                  text: "1중 다겹커튼지",
                  selected: false,
                },
                {
                  code: DesignItemNumber.curcover.quilting_shadenet,
                  text: "1중 다겹커튼지 + 2중 차광망",
                  selected: false,
                },
                {
                  code: DesignItemNumber.curcover.quilting_screen,
                  text: "1중 다겹커튼지 + 2중 스크린",
                  selected: false,
                },
                {
                  code: DesignItemNumber.curcover.quilting_screen_screen,
                  text: "1중 다겹커튼지 + 2중 스크린 + 3중 스크린",
                  selected: false,
                },
              ],
            },
          ],
        },
        {
          text: "지붕(천창) 개폐",
          value: DESIGN_ITEM_CATEGORY2.SKYLIGHT,
          code: DesignItemNumber.skylight.roofswitch.roofswitch,
          selected: true,
          category3: [
            {
              text: "지붕(천창) 개폐",
              value: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF,
              items: [
                {
                  code: DesignItemNumber.skylight.roofswitch.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.skylight.roofswitch.switcher_power,
                  text: "동력 개폐",
                  selected: true,
                },
                {
                  code: DesignItemNumber.skylight.roofswitch.skylight_frame_half,
                  text: "반천창 동력 개폐",
                  selected: false,
                },
                {
                  code: DesignItemNumber.skylight.roofswitch.skylight_frame_rackpinion_way_both,
                  text: "랙피니언 개폐",
                  selected: false,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "환기 시설",
      value: DESIGN_ITEM_CATEGORY1.VENT,
      selected: true,
      category2: [
        {
          text: "외부 배기",
          value: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST,
          category3: [
            {
              text: "외부 배기",
              value: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST,
              items: [
                {
                  code: DesignItemNumber.ventexhaust.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.ventexhaust.vent_exhaust_fan,
                  text: "배기팬",
                  selected: true,
                },
              ],
            },
          ],
        },
        {
          text: "내부 환기",
          value: DESIGN_ITEM_CATEGORY2.VENT_INSIDE,
          selected: false,
          category3: [
            {
              text: "내부 환기",
              value: DESIGN_ITEM_CATEGORY3.VENT_INSIDE,
              items: [
                {
                  code: DesignItemNumber.ventinside.none,
                  text: "없음",
                  selected: true,
                },
                {
                  code: DesignItemNumber.ventinside.vent_inside_air_flow_fan,
                  text: "공기유동팬",
                  selected: false,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "관수 설비",
      value: DESIGN_ITEM_CATEGORY1.WATERING,
      selected: false,
      category2: [
        {
          text: "포그 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_FOG,
          code: DesignItemNumber.watering_fog.watering_fog,
          selected: false,
        },
        {
          text: "스프링클러 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SPRINKLER,
          code: DesignItemNumber.watering_sprinkler.watering_sprinkler,
          selected: false,
        },
        {
          text: "점적 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_DRIP,
          code: DesignItemNumber.watering_drip.watering_drip,
          selected: false,
        },
        {
          text: "수막 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SCREEN,
          code: DesignItemNumber.watering_screen.watering_screen,
          selected: false,
        },
      ],
    },
    {
      text: "양액 설비",
      value: DESIGN_ITEM_CATEGORY1.HYDROPONICS,
      selected: false,
      category2: [
        {
          text: "고형배지 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_SUBSTRATE_CULTURE,
          code: DesignItemNumber.hydroponics_substrate_culture.hydroponics_substrate_culture,
          selected: false,
        },
        {
          text: "NFT 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_NFT,
          code: DesignItemNumber.hydroponics_nft.hydroponics_nft,
          selected: false,
        },
      ],
    },
    {
      text: "냉난방 설비",
      value: DESIGN_ITEM_CATEGORY1.TEMPERATURE,
      selected: false,
      category2: [
        {
          text: "온수 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_WATER,
          code: DesignItemNumber.heating_warm_water.heating_warm_water,
          selected: false,
        },
        {
          text: "증기 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_STEAM,
          code: DesignItemNumber.heating_steam.heating_steam,
          selected: false,
        },
        {
          text: "온풍 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_AIR,
          code: DesignItemNumber.heating_warm_air.heating_warm_air,
          selected: false,
        },
        {
          text: "직열튜브 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_DIRECT_TUBE,
          code: DesignItemNumber.heating_direct_tube.heating_direct_tube,
          selected: false,
        },
        {
          text: "지열히트펌프",
          value: DESIGN_ITEM_CATEGORY2.HEATING_GROUND_PUMP,
          code: DesignItemNumber.heating_ground_pump.heating_ground_pump,
          selected: false,
        },
        {
          text: "물탱크 칠러",
          value: DESIGN_ITEM_CATEGORY2.WATER_TANK_CHILLER,
          code: DesignItemNumber.water_tank_chiller.water_tank_chiller,
          selected: false,
        },
        {
          text: "에어컨",
          value: DESIGN_ITEM_CATEGORY2.AIRCONDITIONER,
          code: DesignItemNumber.airconditioner.airconditioner,
          selected: false,
        },
      ],
    },
    {
      text: "환경 설비",
      value: DESIGN_ITEM_CATEGORY1.ENVIRONMENT,
      selected: false,
      category2: [
        {
          text: "복합환경제어 설비",
          value: DESIGN_ITEM_CATEGORY2.ENVIRONMENT,
          code: DesignItemNumber.environment.environment,
          selected: false,
        },
        {
          text: "CO2 설비",
          value: DESIGN_ITEM_CATEGORY2.CO2,
          code: DesignItemNumber.co2.co2,
          selected: false,
        },
        {
          text: "자동 방제기",
          value: DESIGN_ITEM_CATEGORY2.AUTOSPRAY,
          code: DesignItemNumber.autospray.autospray,
          selected: false,
        },
      ],
    },
    {
      text: "기타 설비",
      value: DESIGN_ITEM_CATEGORY1.OTHER,
      selected: false,
      category2: [
        {
          text: "작업부/작업동",
          value: DESIGN_ITEM_CATEGORY2.WORKROOM,
          code: DesignItemNumber.workroom.workroom,
          selected: false,
        },
        {
          text: "선반/균상다이",
          value: DESIGN_ITEM_CATEGORY2.RACK,
          code: DesignItemNumber.rack.rack,
          selected: false,
        },
        {
          text: "운반 레일",
          value: DESIGN_ITEM_CATEGORY2.RAIL,
          code: DesignItemNumber.rail.rail,
          selected: false,
        },
        {
          text: "지반평탄화/배수로",
          value: DESIGN_ITEM_CATEGORY2.GROUND_FLAT,
          code: DesignItemNumber.ground_flat.ground_flat,
          selected: false,
        },
        {
          text: "바닥 콘크리트",
          value: DESIGN_ITEM_CATEGORY2.CONCRETE,
          code: DesignItemNumber.concrete.concrete,
          selected: false,
        },
        {
          text: "화장실/정화조/관정",
          value: DESIGN_ITEM_CATEGORY2.WASHROOM,
          code: DesignItemNumber.washroom.washroom,
          selected: false,
        },
        {
          text: "컨테이너",
          value: DESIGN_ITEM_CATEGORY2.CONTAINER,
          code: DesignItemNumber.container.container,
          selected: false,
        },
      ],
    },
  ],
  F05: [
    {
      text: "건축 시설",
      value: DESIGN_ITEM_CATEGORY1.ARCHITECTURE,
      selected: true,
      category2: [
        {
          text: "기초",
          value: DESIGN_ITEM_CATEGORY2.FOUNDATION,
          code: DesignItemNumber.foundation.foundation,
          selected: true,
        },
        {
          text: "골조",
          value: DESIGN_ITEM_CATEGORY2.FRAME,
          code: DesignItemNumber.frame.frame,
          selected: true,
          category3: [
            {
              text: "출입문 앞면",
              value: DESIGN_ITEM_CATEGORY3.GATE_FRONT,
              items: [
                {
                  text: "없음",
                  code: DesignItemNumber.frame.gate_front.none,
                  selected: false,
                },
                {
                  text: "미닫이문",
                  code: DesignItemNumber.frame.gate_front.sliding,
                  selected: true,
                },
                {
                  text: "여닫이문",
                  code: DesignItemNumber.frame.gate_front.hinged,
                  selected: false,
                },
              ],
              quantity: [
                { text: "설치 동수", key: "num2", min: 1, max: 100, step: 1, unit: "동" },
                { text: "문짝 개수", key: "num1", min: 1, max: 2, step: 1, unit: "짝" },
              ],
            },
            {
              text: "출입문 뒷면",
              value: DESIGN_ITEM_CATEGORY3.GATE_BACK,
              items: [
                {
                  text: "없음",
                  code: DesignItemNumber.frame.gate_back.none,
                  selected: true,
                },
                {
                  text: "미닫이문",
                  code: DesignItemNumber.frame.gate_back.sliding,
                  selected: false,
                },
                {
                  text: "여닫이문",
                  code: DesignItemNumber.frame.gate_back.hinged,
                  selected: false,
                },
              ],
              quantity: [
                { text: "설치 동수", key: "num2", min: 1, max: 100, step: 1, unit: "동" },
                { text: "문짝 개수", key: "num1", min: 1, max: 2, step: 1, unit: "짝" },
              ],
            },
          ],
        },
        {
          text: "피복",
          value: DESIGN_ITEM_CATEGORY2.COVER,
          code: DesignItemNumber.cover.cover,
          selected: true,
          category3: [
            {
              text: "외부 피복",
              value: DESIGN_ITEM_CATEGORY3.COVER_OUTER,
              items: [
                {
                  code: DesignItemNumber.cover.outerCover.vinyl,
                  text: "비닐",
                  selected: true,
                },
              ],
            },
          ],
        },
        {
          text: "개폐",
          value: DESIGN_ITEM_CATEGORY2.SWITCH,
          code: DesignItemNumber.switch.sideswitch.sideswitch,
          selected: true,
          category3: [
            {
              text: "측면 개폐",
              value: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE,
              items: [
                {
                  code: DesignItemNumber.switch.sideswitch.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.switch.sideswitch.switcher_power,
                  text: "동력 개폐",
                  selected: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "추가 시설",
      value: DESIGN_ITEM_CATEGORY1.ADD,
      selected: true,
      category2: [
        {
          text: "수평 커튼",
          value: DESIGN_ITEM_CATEGORY2.CURTAIN,
          selected: true,
          category3: [
            {
              text: "수평 커튼",
              value: DESIGN_ITEM_CATEGORY3.CURCOVER,
              items: [
                {
                  code: DesignItemNumber.curcover.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.curcover.quilting,
                  text: "1중 다겹커튼지",
                  selected: true,
                },
                {
                  code: DesignItemNumber.curcover.quilting_screen,
                  text: "1중 다겹커튼지 + 2중 스크린",
                  selected: false,
                },
                {
                  code: DesignItemNumber.curcover.quilting_screen_screen,
                  text: "1중 다겹커튼지 + 2중 스크린 + 3중 스크린",
                  selected: false,
                },
              ],
            },
          ],
        },
        {
          text: "지붕(천창) 개폐",
          value: DESIGN_ITEM_CATEGORY2.SKYLIGHT,
          code: DesignItemNumber.skylight.roofswitch.roofswitch,
          selected: true,
          category3: [
            {
              text: "지붕(천창) 개폐",
              value: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF,
              items: [
                {
                  code: DesignItemNumber.skylight.roofswitch.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.skylight.roofswitch.switcher_power,
                  text: "동력 개폐",
                  selected: false,
                },
                {
                  code: DesignItemNumber.skylight.roofswitch.skylight_frame_half,
                  text: "반천창 동력 개폐",
                  selected: false,
                },
                {
                  code: DesignItemNumber.skylight.roofswitch.skylight_frame_rackpinion_way_both,
                  text: "랙피니언 개폐",
                  selected: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "환기 시설",
      value: DESIGN_ITEM_CATEGORY1.VENT,
      selected: true,
      category2: [
        {
          text: "외부 배기",
          value: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST,
          category3: [
            {
              text: "외부 배기",
              value: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST,
              items: [
                {
                  code: DesignItemNumber.ventexhaust.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.ventexhaust.vent_exhaust_fan,
                  text: "배기팬",
                  selected: true,
                },
                // {
                //   code: DesignItemNumber.ventexhaust.vent_exhaust_roof_fan_manual,
                //   text: "지붕 환풍구",
                //   selected: false,
                // },
              ],
            },
          ],
        },
        {
          text: "내부 환기",
          value: DESIGN_ITEM_CATEGORY2.VENT_INSIDE,
          selected: false,
          category3: [
            {
              text: "내부 환기",
              value: DESIGN_ITEM_CATEGORY3.VENT_INSIDE,
              items: [
                {
                  code: DesignItemNumber.ventinside.none,
                  text: "없음",
                  selected: false,
                },
                {
                  code: DesignItemNumber.ventinside.vent_inside_air_flow_fan,
                  text: "공기유동팬",
                  selected: false,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      text: "관수 설비",
      value: DESIGN_ITEM_CATEGORY1.WATERING,
      selected: false,
      category2: [
        {
          text: "포그 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_FOG,
          code: DesignItemNumber.watering_fog.watering_fog,
          selected: false,
        },
        {
          text: "스프링클러 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SPRINKLER,
          code: DesignItemNumber.watering_sprinkler.watering_sprinkler,
          selected: false,
        },
        {
          text: "점적 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_DRIP,
          code: DesignItemNumber.watering_drip.watering_drip,
          selected: false,
        },
        {
          text: "수막 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SCREEN,
          code: DesignItemNumber.watering_screen.watering_screen,
          selected: false,
        },
      ],
    },
    {
      text: "양액 설비",
      value: DESIGN_ITEM_CATEGORY1.HYDROPONICS,
      selected: false,
      category2: [
        {
          text: "고형배지 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_SUBSTRATE_CULTURE,
          code: DesignItemNumber.hydroponics_substrate_culture.hydroponics_substrate_culture,
          selected: false,
        },
        {
          text: "NFT 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_NFT,
          code: DesignItemNumber.hydroponics_nft.hydroponics_nft,
          selected: false,
        },
      ],
    },
    {
      text: "냉난방 설비",
      value: DESIGN_ITEM_CATEGORY1.TEMPERATURE,
      selected: false,
      category2: [
        {
          text: "온수 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_WATER,
          code: DesignItemNumber.heating_warm_water.heating_warm_water,
          selected: false,
        },
        {
          text: "증기 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_STEAM,
          code: DesignItemNumber.heating_steam.heating_steam,
          selected: false,
        },
        {
          text: "온풍 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_AIR,
          code: DesignItemNumber.heating_warm_air.heating_warm_air,
          selected: false,
        },
        {
          text: "직열튜브 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_DIRECT_TUBE,
          code: DesignItemNumber.heating_direct_tube.heating_direct_tube,
          selected: false,
        },
        {
          text: "지열히트펌프",
          value: DESIGN_ITEM_CATEGORY2.HEATING_GROUND_PUMP,
          code: DesignItemNumber.heating_ground_pump.heating_ground_pump,
          selected: false,
        },
        {
          text: "물탱크 칠러",
          value: DESIGN_ITEM_CATEGORY2.WATER_TANK_CHILLER,
          code: DesignItemNumber.water_tank_chiller.water_tank_chiller,
          selected: false,
        },
        {
          text: "에어컨",
          value: DESIGN_ITEM_CATEGORY2.AIRCONDITIONER,
          code: DesignItemNumber.airconditioner.airconditioner,
          selected: false,
        },
      ],
    },
    {
      text: "환경 설비",
      value: DESIGN_ITEM_CATEGORY1.ENVIRONMENT,
      selected: false,
      category2: [
        {
          text: "복합환경제어 설비",
          value: DESIGN_ITEM_CATEGORY2.ENVIRONMENT,
          code: DesignItemNumber.environment.environment,
          selected: false,
        },
        {
          text: "CO2 설비",
          value: DESIGN_ITEM_CATEGORY2.CO2,
          code: DesignItemNumber.co2.co2,
          selected: false,
        },
        {
          text: "자동 방제기",
          value: DESIGN_ITEM_CATEGORY2.AUTOSPRAY,
          code: DesignItemNumber.autospray.autospray,
          selected: false,
        },
      ],
    },
    {
      text: "기타 설비",
      value: DESIGN_ITEM_CATEGORY1.OTHER,
      selected: false,
      category2: [
        {
          text: "작업부/작업동",
          value: DESIGN_ITEM_CATEGORY2.WORKROOM,
          code: DesignItemNumber.workroom.workroom,
          selected: false,
        },
        {
          text: "선반/균상다이",
          value: DESIGN_ITEM_CATEGORY2.RACK,
          code: DesignItemNumber.rack.rack,
          selected: false,
        },
        {
          text: "운반 레일",
          value: DESIGN_ITEM_CATEGORY2.RAIL,
          code: DesignItemNumber.rail.rail,
          selected: false,
        },
        {
          text: "지반평탄화/배수로",
          value: DESIGN_ITEM_CATEGORY2.GROUND_FLAT,
          code: DesignItemNumber.ground_flat.ground_flat,
          selected: false,
        },
        {
          text: "바닥 콘크리트",
          value: DESIGN_ITEM_CATEGORY2.CONCRETE,
          code: DesignItemNumber.concrete.concrete,
          selected: false,
        },
        {
          text: "화장실/정화조/관정",
          value: DESIGN_ITEM_CATEGORY2.WASHROOM,
          code: DesignItemNumber.washroom.washroom,
          selected: false,
        },
        {
          text: "컨테이너",
          value: DESIGN_ITEM_CATEGORY2.CONTAINER,
          code: DesignItemNumber.container.container,
          selected: false,
        },
      ],
    },
  ],
  F11: [
    {
      text: "건축 시설",
      value: DESIGN_ITEM_CATEGORY1.ARCHITECTURE,
      selected: false,
      category2: [
        {
          text: "기초",
          value: DESIGN_ITEM_CATEGORY2.FOUNDATION,
          code: DesignItemNumber.foundation.foundation,
          selected: false,
        },
        {
          text: "골조",
          value: DESIGN_ITEM_CATEGORY2.FRAME,
          code: DesignItemNumber.frame.frame,
          selected: false,
        },
        {
          text: "피복",
          value: DESIGN_ITEM_CATEGORY2.COVER,
          code: DesignItemNumber.cover.cover,
          selected: false,
        },
        {
          text: "개폐",
          value: DESIGN_ITEM_CATEGORY2.SWITCH,
          code: DesignItemNumber.switch.sideswitch.sideswitch,
          selected: false,
        },
      ],
    },
    {
      text: "추가 시설",
      value: DESIGN_ITEM_CATEGORY1.ADD,
      selected: false,
      category2: [
        {
          text: "수평 커튼",
          value: DESIGN_ITEM_CATEGORY2.CURTAIN,
          code: DesignItemNumber.curcover.curcover,
          selected: false,
        },
        {
          text: "지붕(천창) 개폐",
          value: DESIGN_ITEM_CATEGORY2.SKYLIGHT,
          code: DesignItemNumber.skylight.roofswitch.roofswitch,
          selected: false,
        },
      ],
    },
    {
      text: "환기 시설",
      value: DESIGN_ITEM_CATEGORY1.VENT,
      selected: false,
      category2: [
        {
          text: "외부 배기",
          value: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST,
          code: DesignItemNumber.ventexhaust.ventexhaust,
          selected: false,
        },
        {
          text: "내부 환기",
          value: DESIGN_ITEM_CATEGORY2.VENT_INSIDE,
          code: DesignItemNumber.ventinside.ventinside,
          selected: false,
        },
        {
          text: "샷시 창문",
          value: DESIGN_ITEM_CATEGORY2.SASH_WINDOW,
          code: DesignItemNumber.window.window,
          selected: false,
        },
      ],
    },
    {
      text: "관수 설비",
      value: DESIGN_ITEM_CATEGORY1.WATERING,
      selected: false,
      category2: [
        {
          text: "포그 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_FOG,
          code: DesignItemNumber.watering_fog.watering_fog,
          selected: false,
        },
        {
          text: "스프링클러 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SPRINKLER,
          code: DesignItemNumber.watering_sprinkler.watering_sprinkler,
          selected: false,
        },
        {
          text: "점적 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_DRIP,
          code: DesignItemNumber.watering_drip.watering_drip,
          selected: false,
        },
        {
          text: "수막 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SCREEN,
          code: DesignItemNumber.watering_screen.watering_screen,
          selected: false,
        },
      ],
    },
    {
      text: "양액 설비",
      value: DESIGN_ITEM_CATEGORY1.HYDROPONICS,
      selected: false,
      category2: [
        {
          text: "고형배지 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_SUBSTRATE_CULTURE,
          code: DesignItemNumber.hydroponics_substrate_culture.hydroponics_substrate_culture,
          selected: false,
        },
        {
          text: "NFT 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_NFT,
          code: DesignItemNumber.hydroponics_nft.hydroponics_nft,
          selected: false,
        },
      ],
    },
    {
      text: "냉난방 설비",
      value: DESIGN_ITEM_CATEGORY1.TEMPERATURE,
      selected: false,
      category2: [
        {
          text: "온수 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_WATER,
          code: DesignItemNumber.heating_warm_water.heating_warm_water,
          selected: false,
        },
        {
          text: "증기 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_STEAM,
          code: DesignItemNumber.heating_steam.heating_steam,
          selected: false,
        },
        {
          text: "온풍 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_AIR,
          code: DesignItemNumber.heating_warm_air.heating_warm_air,
          selected: false,
        },
        {
          text: "직열튜브 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_DIRECT_TUBE,
          code: DesignItemNumber.heating_direct_tube.heating_direct_tube,
          selected: false,
        },
        {
          text: "지열히트펌프",
          value: DESIGN_ITEM_CATEGORY2.HEATING_GROUND_PUMP,
          code: DesignItemNumber.heating_ground_pump.heating_ground_pump,
          selected: false,
        },
        {
          text: "물탱크 칠러",
          value: DESIGN_ITEM_CATEGORY2.WATER_TANK_CHILLER,
          code: DesignItemNumber.water_tank_chiller.water_tank_chiller,
          selected: false,
        },
        {
          text: "에어컨",
          value: DESIGN_ITEM_CATEGORY2.AIRCONDITIONER,
          code: DesignItemNumber.airconditioner.airconditioner,
          selected: false,
        },
      ],
    },
    {
      text: "환경 설비",
      value: DESIGN_ITEM_CATEGORY1.ENVIRONMENT,
      selected: true,
      category2: [
        {
          text: "복합환경제어 설비",
          value: DESIGN_ITEM_CATEGORY2.ENVIRONMENT,
          code: DesignItemNumber.environment.environment,
          selected: true,
        },
        {
          text: "CO2 설비",
          value: DESIGN_ITEM_CATEGORY2.CO2,
          code: DesignItemNumber.co2.co2,
          selected: false,
        },
        {
          text: "자동 방제기",
          value: DESIGN_ITEM_CATEGORY2.AUTOSPRAY,
          code: DesignItemNumber.autospray.autospray,
          selected: false,
        },
      ],
    },
    {
      text: "기타 설비",
      value: DESIGN_ITEM_CATEGORY1.OTHER,
      selected: false,
      category2: [
        {
          text: "작업부/작업동",
          value: DESIGN_ITEM_CATEGORY2.WORKROOM,
          code: DesignItemNumber.workroom.workroom,
          selected: false,
        },
        {
          text: "선반/균상다이",
          value: DESIGN_ITEM_CATEGORY2.RACK,
          code: DesignItemNumber.rack.rack,
          selected: false,
        },
        {
          text: "운반 레일",
          value: DESIGN_ITEM_CATEGORY2.RAIL,
          code: DesignItemNumber.rail.rail,
          selected: false,
        },
        {
          text: "지반평탄화/배수로",
          value: DESIGN_ITEM_CATEGORY2.GROUND_FLAT,
          code: DesignItemNumber.ground_flat.ground_flat,
          selected: false,
        },
        {
          text: "바닥 콘크리트",
          value: DESIGN_ITEM_CATEGORY2.CONCRETE,
          code: DesignItemNumber.concrete.concrete,
          selected: false,
        },
        {
          text: "화장실/정화조/관정",
          value: DESIGN_ITEM_CATEGORY2.WASHROOM,
          code: DesignItemNumber.washroom.washroom,
          selected: false,
        },
        {
          text: "컨테이너",
          value: DESIGN_ITEM_CATEGORY2.CONTAINER,
          code: DesignItemNumber.container.container,
          selected: false,
        },
      ],
    },
  ],
  OTHER: [
    {
      text: "건축 시설",
      value: DESIGN_ITEM_CATEGORY1.ARCHITECTURE,
      selected: false,
      category2: [
        {
          text: "기초",
          value: DESIGN_ITEM_CATEGORY2.FOUNDATION,
          code: DesignItemNumber.foundation.foundation,
          selected: false,
        },
        {
          text: "골조",
          value: DESIGN_ITEM_CATEGORY2.FRAME,
          code: DesignItemNumber.frame.frame,
          selected: false,
        },
        {
          text: "피복",
          value: DESIGN_ITEM_CATEGORY2.COVER,
          code: DesignItemNumber.cover.cover,
          selected: false,
        },
        {
          text: "개폐",
          value: DESIGN_ITEM_CATEGORY2.SWITCH,
          code: DesignItemNumber.switch.sideswitch.sideswitch,
          selected: false,
        },
      ],
    },
    {
      text: "추가 시설",
      value: DESIGN_ITEM_CATEGORY1.ADD,
      selected: false,
      category2: [
        {
          text: "수평 커튼",
          value: DESIGN_ITEM_CATEGORY2.CURTAIN,
          code: DesignItemNumber.curcover.curcover,
          selected: false,
        },
        {
          text: "지붕(천창) 개폐",
          value: DESIGN_ITEM_CATEGORY2.SKYLIGHT,
          code: DesignItemNumber.skylight.roofswitch.roofswitch,
          selected: false,
        },
      ],
    },
    {
      text: "환기 시설",
      value: DESIGN_ITEM_CATEGORY1.VENT,
      selected: false,
      category2: [
        {
          text: "외부 배기",
          value: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST,
          code: DesignItemNumber.ventexhaust.ventexhaust,
          selected: false,
        },
        {
          text: "내부 환기",
          value: DESIGN_ITEM_CATEGORY2.VENT_INSIDE,
          code: DesignItemNumber.ventinside.ventinside,
          selected: false,
        },
        {
          text: "샷시 창문",
          value: DESIGN_ITEM_CATEGORY2.SASH_WINDOW,
          code: DesignItemNumber.window.window,
          selected: false,
        },
      ],
    },
    {
      text: "관수 설비",
      value: DESIGN_ITEM_CATEGORY1.WATERING,
      selected: false,
      category2: [
        {
          text: "포그 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_FOG,
          code: DesignItemNumber.watering_fog.watering_fog,
          selected: false,
        },
        {
          text: "스프링클러 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SPRINKLER,
          code: DesignItemNumber.watering_sprinkler.watering_sprinkler,
          selected: false,
        },
        {
          text: "점적 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_DRIP,
          code: DesignItemNumber.watering_drip.watering_drip,
          selected: false,
        },
        {
          text: "수막 관수",
          value: DESIGN_ITEM_CATEGORY2.WATERING_SCREEN,
          code: DesignItemNumber.watering_screen.watering_screen,
          selected: false,
        },
      ],
    },
    {
      text: "양액 설비",
      value: DESIGN_ITEM_CATEGORY1.HYDROPONICS,
      selected: false,
      category2: [
        {
          text: "고형배지 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_SUBSTRATE_CULTURE,
          code: DesignItemNumber.hydroponics_substrate_culture.hydroponics_substrate_culture,
          selected: false,
        },
        {
          text: "NFT 양액 설비",
          value: DESIGN_ITEM_CATEGORY2.HYDROPONICS_NFT,
          code: DesignItemNumber.hydroponics_nft.hydroponics_nft,
          selected: false,
        },
      ],
    },
    {
      text: "냉난방 설비",
      value: DESIGN_ITEM_CATEGORY1.TEMPERATURE,
      selected: false,
      category2: [
        {
          text: "온수 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_WATER,
          code: DesignItemNumber.heating_warm_water.heating_warm_water,
          selected: false,
        },
        {
          text: "증기 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_STEAM,
          code: DesignItemNumber.heating_steam.heating_steam,
          selected: false,
        },
        {
          text: "온풍 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_WARM_AIR,
          code: DesignItemNumber.heating_warm_air.heating_warm_air,
          selected: false,
        },
        {
          text: "직열튜브 난방",
          value: DESIGN_ITEM_CATEGORY2.HEATING_DIRECT_TUBE,
          code: DesignItemNumber.heating_direct_tube.heating_direct_tube,
          selected: false,
        },
        {
          text: "지열히트펌프",
          value: DESIGN_ITEM_CATEGORY2.HEATING_GROUND_PUMP,
          code: DesignItemNumber.heating_ground_pump.heating_ground_pump,
          selected: false,
        },
        {
          text: "물탱크 칠러",
          value: DESIGN_ITEM_CATEGORY2.WATER_TANK_CHILLER,
          code: DesignItemNumber.water_tank_chiller.water_tank_chiller,
          selected: false,
        },
        {
          text: "에어컨",
          value: DESIGN_ITEM_CATEGORY2.AIRCONDITIONER,
          code: DesignItemNumber.airconditioner.airconditioner,
          selected: false,
        },
      ],
    },
    {
      text: "환경 설비",
      value: DESIGN_ITEM_CATEGORY1.ENVIRONMENT,
      selected: false,
      category2: [
        {
          text: "복합환경제어 설비",
          value: DESIGN_ITEM_CATEGORY2.ENVIRONMENT,
          code: DesignItemNumber.environment.environment,
          selected: false,
        },
        {
          text: "CO2 설비",
          value: DESIGN_ITEM_CATEGORY2.CO2,
          code: DesignItemNumber.co2.co2,
          selected: false,
        },
        {
          text: "자동 방제기",
          value: DESIGN_ITEM_CATEGORY2.AUTOSPRAY,
          code: DesignItemNumber.autospray.autospray,
          selected: false,
        },
      ],
    },
    {
      text: "기타 설비",
      value: DESIGN_ITEM_CATEGORY1.OTHER,
      selected: false,
      category2: [
        {
          text: "작업부/작업동",
          value: DESIGN_ITEM_CATEGORY2.WORKROOM,
          code: DesignItemNumber.workroom.workroom,
          selected: false,
        },
        {
          text: "선반/균상다이",
          value: DESIGN_ITEM_CATEGORY2.RACK,
          code: DesignItemNumber.rack.rack,
          selected: false,
        },
        {
          text: "운반 레일",
          value: DESIGN_ITEM_CATEGORY2.RAIL,
          code: DesignItemNumber.rail.rail,
          selected: false,
        },
        {
          text: "지반평탄화/배수로",
          value: DESIGN_ITEM_CATEGORY2.GROUND_FLAT,
          code: DesignItemNumber.ground_flat.ground_flat,
          selected: false,
        },
        {
          text: "바닥 콘크리트",
          value: DESIGN_ITEM_CATEGORY2.CONCRETE,
          code: DesignItemNumber.concrete.concrete,
          selected: false,
        },
        {
          text: "화장실/정화조/관정",
          value: DESIGN_ITEM_CATEGORY2.WASHROOM,
          code: DesignItemNumber.washroom.washroom,
          selected: false,
        },
        {
          text: "컨테이너",
          value: DESIGN_ITEM_CATEGORY2.CONTAINER,
          code: DesignItemNumber.container.container,
          selected: false,
        },
      ],
    },
  ],
};

export const inboundConFacilityDetailData = [
  {
    title: "건축 시설",
    expand: false,
    children: [
      {
        code: "A01",
        title: "기초",
        selected: false,
      },
      {
        code: "A02",
        title: "골조",
        selected: false,
      },
      {
        code: "A03",
        title: "피복",
        selected: false,
      },
      {
        code: "A04",
        title: "개폐",
        selected: false,
      },
    ],
  },
  {
    title: "추가 시설",
    expand: false,
    children: [
      {
        code: "B01",
        title: "수평 커튼",
        selected: false,
      },
      {
        code: "B02",
        title: "천창 개폐(몽골)",
        selected: false,
      },
    ],
  },
  {
    title: "환기 설비",
    expand: false,
    children: [
      {
        code: "C01",
        title: "앞뒷면 배기팬",
        selected: false,
      },
      {
        code: "C02",
        title: "지붕 환기구",
        selected: false,
      },
      {
        code: "C03",
        title: "내부 공기 유동팬",
        selected: false,
      },
      {
        code: "H07",
        title: "샷시 창문",
        selected: false,
      },
    ],
  },
  {
    title: "관수 설비",
    expand: false,
    children: [
      {
        code: "D01",
        title: "포그 관수",
        selected: false,
      },
      {
        code: "D02",
        title: "스프링클러 관수",
        selected: false,
      },
      {
        code: "D03",
        title: "점적 관수",
        selected: false,
      },
      {
        code: "D04",
        title: "수막 관수",
        selected: false,
      },
    ],
  },
  {
    title: "양액 설비",
    expand: false,
    children: [
      {
        code: "E01",
        title: "고형배지 양액",
        selected: false,
      },
      {
        code: "E02",
        title: "NFT 양액",
        selected: false,
      },
    ],
  },
  {
    title: "냉난방 설비",
    expand: false,
    children: [
      {
        code: "F02",
        title: "증기 난방",
        selected: false,
      },
      {
        code: "F03",
        title: "온풍 난방",
        selected: false,
      },
      {
        code: "F01",
        title: "온수 난방",
        selected: false,
      },
      {
        code: "F04",
        title: "직열튜브 난방",
        selected: false,
      },
      {
        code: "F05",
        title: "지열히트펌프",
        selected: false,
      },
      {
        code: "F06",
        title: "물탱크 칠러",
        selected: false,
      },
      {
        code: "F07",
        title: "에어컨",
        selected: false,
      },
    ],
  },
  {
    title: "환경 설비",
    expand: false,
    children: [
      {
        code: "G01",
        title: "복합환경제어 설비",
        selected: false,
      },
      {
        code: "G02",
        title: "CO2 설비",
        selected: false,
      },
      {
        code: "G03",
        title: "자동 방제기 설비",
        selected: false,
      },
    ],
  },
  {
    title: "기타 설비",
    expand: false,
    children: [
      {
        code: "H01",
        title: "작업부/작업동",
        selected: false,
      },
      {
        code: "H02",
        title: "선반/균상다이",
        selected: false,
      },
      {
        code: "H03",
        title: "운반 레일",
        selected: false,
      },
      {
        code: "H04",
        title: "지반평탄화/배수로",
        selected: false,
      },
      {
        code: "H05",
        title: "바닥 콘크리트",
        selected: false,
      },
      {
        code: "H06",
        title: "화장실/정화조/관정",
        selected: false,
      },

      {
        code: "H08",
        title: "컨테이너",
        selected: false,
      },
    ],
  },
];

export const INBOUND_COUNSEL_PUBLIC = `- 고객명:
- 연락처:
- 시공예정일:
- 시공지주소:
- 토지소유:
- 정부사업:
- 최대예산:
- 용도/작물:
- 요청사항:
- 거래방식:

기본 정보
- 시설유형: 연동 하우스, ?중, ?동
- 시설규격: 한동 폭0m(00m) x 길이00m x 00동 = 00평
 * 측고0m, 매설0m
- 토지규격: 폭00m x 길이00 = 00평


건축 시설
- 기초:
- 골조:
 * 기둥 각60 2.3t 4.5m, 2m간격
 * 지붕 2중: 서까래 32mm 1.5T 12m(10+2), 0.6m간격
 * 방풍벽 2중
 * 마구리 2중
 * 출입문 앞면 미닫이, 뒷면 미닫이
- 피복:
 * 비닐
 * 방충망
- 수평 커튼:
 * 1중: 다겹커튼지
 * 2중: AL스크린/차광망
- 개폐:
 * 동력개폐/수동개폐
 * 수동제어/반자동제어/자동제어
- 천창 개폐(몽골):
 * 반천창형/랙피니언
- 환기:
 * 앞뒷면 배기팬: ?개
 * 지붕 환기구: ?개
 * 내부 공기유동팬: ?개

관수 설비
- 포그 관수:
- 스프링클러 관수:
- 점적 관수: ?줄
 * 관비기
- 수막 관수:

양액 설비
- 양액 설비:
 * 고형배지/NFT
 * 비순환/순환
 * 양액시스템: 별도/관비기급/고급/최고급
- 베드 설비: ?줄
 * 고설/행잉고정/행잉이동
- 지면레일: ?줄

냉난방 설비
- 온수 난방:
- 증기 난방:
- 온풍 난방:
- 직열튜브 난방:
- 지열히트펌프:
- 물탱크 칠러:
- 에어컨:

복합/기타 설비
- 복합환경제어 설비:
 * 단순제어-일반/고급/최고급/별도
 * 복합제어-일반/고급/최고급/수입/별도
- CO2 설비:
- 자동 방제기: 고정형/이동형

기타/토목
- 작업부/작업동:
- 선반/균상다이:
 * 독립형
 * 선반 폭90cm 3줄(통로 폭90cm 5줄), 길이?m
 * 선반틀 기둥 32mm 1.5T, 2m간격
 * 선반단 6단 높이25cm, 다리30cm
 * 선반바닥 직관 25mm 1.5T, 4줄
- 운반 레일:
 * 상단/측면/지면 ?줄
 * 운반구: ?개
- 지반평탄화/배수로: ?일
- 바닥 콘크리트: ?평 * 20cm, ?루베
- 화장실/정화조/관정: `;

export const INBOUND_COUNSEL_INTERNAL = `- 본사 특이사항: ` + `\n\n- 전문가 특이사항: `;

export const counselDesignItemsInitData: any = [
  {
    itemNumber: DesignItemNumber.foundation.foundation,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.FOUNDATION },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.frame.frame,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.FRAME },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.frame.gate_front.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.FRAME },
    category3: { code: DESIGN_ITEM_CATEGORY3.GATE_FRONT },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.frame.gate_front.sliding,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.FRAME },
    category3: { code: DESIGN_ITEM_CATEGORY3.GATE_FRONT },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.frame.gate_front.hinged,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.FRAME },
    category3: { code: DESIGN_ITEM_CATEGORY3.GATE_FRONT },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.frame.gate_back.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.FRAME },
    category3: { code: DESIGN_ITEM_CATEGORY3.GATE_BACK },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.frame.gate_back.sliding,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.FRAME },
    category3: { code: DESIGN_ITEM_CATEGORY3.GATE_BACK },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.frame.gate_back.hinged,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.FRAME },
    category3: { code: DESIGN_ITEM_CATEGORY3.GATE_BACK },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.cover,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.outerCover.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_OUTER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.outerCover.vinyl,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_OUTER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.outerCover.cover2,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_OUTER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.outerCover.cover1,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_OUTER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.outerCover.cover4,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_OUTER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.outerCover.cover5,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_OUTER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.innerCover.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_INNER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.innerCover.vinyl,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_INNER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.innerCover.vinyl_nonwoven,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_INNER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.cover.innerCover.vinyl_quilting,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.COVER },
    category3: { code: DESIGN_ITEM_CATEGORY3.COVER_INNER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.switch.sideswitch.sideswitch,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.SWITCH },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.switch.sideswitch.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.SWITCH },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.switch.sideswitch.switcher_manual,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.SWITCH },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.switch.sideswitch.switcher_power,
    category1: { code: DESIGN_ITEM_CATEGORY1.ARCHITECTURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.SWITCH },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_SIDE },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.curcover.curcover,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.CURTAIN },
    category3: { code: DESIGN_ITEM_CATEGORY3.CURCOVER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.curcover.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.CURTAIN },
    category3: { code: DESIGN_ITEM_CATEGORY3.CURCOVER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.curcover.quilting,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.CURTAIN },
    category3: { code: DESIGN_ITEM_CATEGORY3.CURCOVER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.curcover.quilting_screen,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.CURTAIN },
    category3: { code: DESIGN_ITEM_CATEGORY3.CURCOVER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.curcover.quilting_screen_screen,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.CURTAIN },
    category3: { code: DESIGN_ITEM_CATEGORY3.CURCOVER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.curcover.quilting_shadenet,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.CURTAIN },
    category3: { code: DESIGN_ITEM_CATEGORY3.CURCOVER },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.skylight.roofswitch.roofswitch,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.SKYLIGHT },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.skylight.roofswitch.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.SKYLIGHT },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.skylight.roofswitch.skylight_frame_half,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.SKYLIGHT },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.skylight.roofswitch.skylight_frame_rackpinion_way_both,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.SKYLIGHT },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.skylight.roofswitch.switcher_power,
    category1: { code: DESIGN_ITEM_CATEGORY1.ADD },
    category2: { code: DESIGN_ITEM_CATEGORY2.SKYLIGHT },
    category3: { code: DESIGN_ITEM_CATEGORY3.SWITCH_ROOF },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.ventexhaust.ventexhaust,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.ventexhaust.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST },
    category3: { code: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.ventexhaust.vent_exhaust_roof_fan_manual,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST },
    category3: { code: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.ventexhaust.vent_exhaust_fan,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST },
    category3: { code: DESIGN_ITEM_CATEGORY3.VENT_EXHAUST },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.ventinside.ventinside,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.VENT_EXHAUST },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.ventinside.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.VENT_INSIDE },
    category3: { code: DESIGN_ITEM_CATEGORY3.VENT_INSIDE },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.ventinside.vent_inside_air_flow_fan,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.VENT_INSIDE },
    category3: { code: DESIGN_ITEM_CATEGORY3.VENT_INSIDE },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.window.window,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.SASH_WINDOW },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.window.none,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.SASH_WINDOW },
    category3: { code: DESIGN_ITEM_CATEGORY3.WINDOW },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.window.window_hinged,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.SASH_WINDOW },
    category3: { code: DESIGN_ITEM_CATEGORY3.WINDOW },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.window.window_sash_frame,
    category1: { code: DESIGN_ITEM_CATEGORY1.VENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.SASH_WINDOW },
    category3: { code: DESIGN_ITEM_CATEGORY3.WINDOW },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.watering_fog.watering_fog,
    category1: { code: DESIGN_ITEM_CATEGORY1.WATERING },
    category2: { code: DESIGN_ITEM_CATEGORY2.WATERING_FOG },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.watering_sprinkler.watering_sprinkler,
    category1: { code: DESIGN_ITEM_CATEGORY1.WATERING },
    category2: { code: DESIGN_ITEM_CATEGORY2.WATERING_SPRINKLER },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.watering_drip.watering_drip,
    category1: { code: DESIGN_ITEM_CATEGORY1.WATERING },
    category2: { code: DESIGN_ITEM_CATEGORY2.WATERING_DRIP },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.watering_screen.watering_screen,
    category1: { code: DESIGN_ITEM_CATEGORY1.WATERING },
    category2: { code: DESIGN_ITEM_CATEGORY2.WATERING_SCREEN },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.hydroponics_substrate_culture.hydroponics_substrate_culture,
    category1: { code: DESIGN_ITEM_CATEGORY1.HYDROPONICS },
    category2: { code: DESIGN_ITEM_CATEGORY2.HYDROPONICS_SUBSTRATE_CULTURE },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.hydroponics_nft.hydroponics_nft,
    category1: { code: DESIGN_ITEM_CATEGORY1.HYDROPONICS },
    category2: { code: DESIGN_ITEM_CATEGORY2.HYDROPONICS_NFT },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.heating_warm_water.heating_warm_water,
    category1: { code: DESIGN_ITEM_CATEGORY1.TEMPERATURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.HEATING_WARM_WATER },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.heating_steam.heating_steam,
    category1: { code: DESIGN_ITEM_CATEGORY1.TEMPERATURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.HEATING_STEAM },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.heating_warm_air.heating_warm_air,
    category1: { code: DESIGN_ITEM_CATEGORY1.TEMPERATURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.HEATING_WARM_AIR },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.heating_direct_tube.heating_direct_tube,
    category1: { code: DESIGN_ITEM_CATEGORY1.TEMPERATURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.HEATING_DIRECT_TUBE },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.heating_ground_pump.heating_ground_pump,
    category1: { code: DESIGN_ITEM_CATEGORY1.TEMPERATURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.HEATING_GROUND_PUMP },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.water_tank_chiller.water_tank_chiller,
    category1: { code: DESIGN_ITEM_CATEGORY1.TEMPERATURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.WATER_TANK_CHILLER },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.airconditioner.airconditioner,
    category1: { code: DESIGN_ITEM_CATEGORY1.TEMPERATURE },
    category2: { code: DESIGN_ITEM_CATEGORY2.AIRCONDITIONER },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.environment.environment,
    category1: { code: DESIGN_ITEM_CATEGORY1.ENVIRONMENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.ENVIRONMENT },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.co2.co2,
    category1: { code: DESIGN_ITEM_CATEGORY1.ENVIRONMENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.CO2 },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.autospray.autospray,
    category1: { code: DESIGN_ITEM_CATEGORY1.ENVIRONMENT },
    category2: { code: DESIGN_ITEM_CATEGORY2.AUTOSPRAY },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.workroom.workroom,
    category1: { code: DESIGN_ITEM_CATEGORY1.OTHER },
    category2: { code: DESIGN_ITEM_CATEGORY2.WORKROOM },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.rack.rack,
    category1: { code: DESIGN_ITEM_CATEGORY1.OTHER },
    category2: { code: DESIGN_ITEM_CATEGORY2.RACK },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.rail.rail,
    category1: { code: DESIGN_ITEM_CATEGORY1.OTHER },
    category2: { code: DESIGN_ITEM_CATEGORY2.RAIL },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.ground_flat.ground_flat,
    category1: { code: DESIGN_ITEM_CATEGORY1.OTHER },
    category2: { code: DESIGN_ITEM_CATEGORY2.GROUND_FLAT },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.concrete.concrete,
    category1: { code: DESIGN_ITEM_CATEGORY1.OTHER },
    category2: { code: DESIGN_ITEM_CATEGORY2.CONCRETE },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.washroom.washroom,
    category1: { code: DESIGN_ITEM_CATEGORY1.OTHER },
    category2: { code: DESIGN_ITEM_CATEGORY2.WASHROOM },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
  {
    itemNumber: DesignItemNumber.container.container,
    category1: { code: DESIGN_ITEM_CATEGORY1.OTHER },
    category2: { code: DESIGN_ITEM_CATEGORY2.CONTAINER },
    category3: { code: DESIGN_ITEM_CATEGORY3.NOTHING },
    itemCount: 1,
    num1: null,
    num2: null,
    str1: null,
    str2: null,
    enabled: false,
  },
];

export const CounselFactorData = {
  treeLevelItems: [
    {
      value: "공사",
      text: "공사 보기",
    },
    {
      value: "시설",
      text: "시설 보기",
    },
  ],
  unitCostPerType: [
    {
      code: "01",
      value: "평 당",
    },
    {
      code: "02",
      value: "동 당",
    },
    {
      code: "03",
      value: "개 당",
    },
  ],
  itemType: [
    {
      code: ITEM_TYPE.DETAIL,
      value: "시설 상세",
    },
    {
      code: ITEM_TYPE.INTEREST,
      value: "관심 시설",
    },
  ],
  calcType: [
    {
      code: CALC_TYPE.HCOST,
      value: "간편 견적",
    },
    {
      code: CALC_TYPE.VHOWS,
      value: "상세 견적",
    },
  ],
};

export const CounselModelData: CounselModel = {
  id: null,
  uuid: null,
  title: null,
  designModelItems: [
    {
      itemNumber: null,
      parentItemNumber: null,
      orderIndex: null,
      category1: null,
      category2: null,
      category3: null,
      itemValue: null,
      itemType: null,
      description: null,
      itemCount: null,
      num1: null,
      num2: null,
      str1: null,
      str2: null,
      selected: null,
      published: null,
      itemName: null,
    },
  ],
  orderIndex: null,
  facilityType: null,
  published: null,
  description: null,
};
